document.res_ = {
	// ── PL.tip: the headed tip box builds its own header (was #{global.tip} markup) ──
	tipHeader_title: "Tip",
	// the guided tooltip's × (js/pl/tip.js) — aria-label only, the glyph carries no text
	tipClose_label: "Close",
	// ── Touch layer: a tablet held upright (js/touch/panes.js, R6) — the dismissible landscape hint ──
	touchRotateHint_body: "Turn your tablet sideways: a side panel then fits next to the page.",
	touchRotateHintClose_label: "Close",
	// ── Touch layer: the tap copy (tablet-support-plan.md §7b, S7) ──
	// js/touch/copy.js reads <key>_touch in place of <key> on a touch device (seam T-16, util.js
	// getRes). Same meaning, the finger's verb; a line that offered Enter/Esc as the other way drops it.
	obTourWlAdd_body_touch: "Tap this button and pick a list — the word goes straight into the one you choose. Word lists are how you collect exactly the words you want to learn and practice.",
	obTourMyList_body_touch: "All the words and phrases you have added to your word list are here. Tap it to open the list.",
	obTourBandAdd_body_touch: "Every list has one: it moves words from the list into your tray. Tap it.",
	obTourBandFive_body_touch: "Tap the small arrow beside 5 and five random words are picked.",
	obWlOffer_body_touch: "Now you are ready — tap “Start Learning!” and learn your new words.\n\nBut before you move on, let me show you the Word Lists a little more closely. There is a lot to find there! You can also take the Word list tour later, from the help menu {?}.\n\nDo you want to continue the tour?",
	obWlGarden_body_touch: "Every word you have planted grows here, sorted by how well you know it. Tap My Garden to open it.",
	obWlLevels_body_touch: "All the dictionary words are split into lists by level, from the easiest to the hardest. Tap a list to open it and see its words.",
	obWlTopicPick_body_touch: "Eighteen lists behind a single row — food, travel, work, and the rest. Tap the highlighted one to open it.",
	obWlTopicWord_body_touch: "Tap a word in any word list to see its dictionary entry. Try the highlighted one.",
	obWlFilter_body_touch: "Tap the magnifying glass to quickly find words in all your word lists.",
	obWlNew_body_touch: "Tap this button to create a new word list — collect the words there by lesson, by song, by topic, however you like.",
	obWlNewUse_body_touch: "Next time you tap {0} on a word you want to keep, you will be able to send it to this list.",
	obMeetReveal_body_touch: "Have a guess, then tap the prompt to see what it means.",
	obTourRowOpen_touch: "Tap the word to open its entry — the button that takes it to Learn is there.",
	obMeetEntry_body_touch: "Every word you meet comes with a full dictionary entry — meanings, grammar, examples and pronunciation. The translation is at the top, everything else below. Press and hold a word or a label to see what it means.",
	obMeetGotIt_body_touch: "Tap “{0}” when you have finished reading.",
	obTipExpStart_body_touch: "<p>Tap Start Learning to meet your first couple of words — picked at random for your level for this first session. Later on you can choose any words you like yourself.</p><p>One more thing: while the tour runs, most of the app is deliberately out of reach, so nothing distracts from the simplest path. Once it ends, everything is yours to use.</p>",
	obTipExpList_body_touch: "Tap this dictionary word list to open it.",
	obTipExpChip_body_touch: "Tap this letter to open the dictionary's easiest word list.",
	obTipExpAdd_body_touch: "This button adds words from the open list to your learning tray — tap it and pick how many.",
	obGuideFive_body_touch: "Tap the small arrow and 3 random words land in your learning tray.",
	obGuideFiveNext_body_touch: "Tap the small arrow and 5 random words land in your learning tray.",
	obGuideDrill_body_touch: "Tap Start Exercise! — a short timed drill makes these words stick.",
	obTipSpacePron_body_touch: "Tap the speaker button to hear the word pronounced. It appears wherever the word can be heard.",
	obTipThirsty_body_touch: "Some of your plants are thirsty. Tap the chip to stage exactly those words for a quick watering round.",
	learnStudyTerm_tooltip_touch: "Tap to open the full dictionary entry for this word",
	learnMeet_reveal_label_touch: "Do you know the translation? Tap here to reveal it",
	learnQ_pickHint_touch: "Tap the correct card",
	stopButton_tooltip_touch: "Tap to stop the exercise and return to the main page",
	phraseBand_pagerRow_tooltip_touch: "Rows {0}–{1} of {2} — tap to jump",
	startButton_tooltip_touch: "Tap to start learning words!",
	practiceDir_mix_tooltip_touch: "Tap both directions for a mixed session: every word goes the way it did NOT go last time<p/>(the set stays the same length — one card per word)",
	pauseButton_tooltip_touch: "Tap to pause learning words",
	continueButton_tooltip_touch: "Tap to continue learning words",
	richTerm_tooltip_touch: "Tap to collapse — or use the browser's Back button to exit this view",
	revealTerm_tooltip_touch: "Tap to open the dictionary entry",
	pronDialPlay_hint_touch: "tap to hear it",
	wlGarden_tooltip_touch: "Every word you have actually touched — what needs watering, what you started, and what is growing<p/>Tap the flower to see the whole garden",
	wlLevelSort_tooltip_touch: "How this list is ordered — tap to switch",
	wlLevelCompactHint_tooltip_touch: "<p>Double-tap: fold the level rows into one strip.</p><p>Double-tap the 📖 there to unfold.</p><p>Also: account menu ▸ Settings ▸ Word list settings.</p>",
	wlLevelExpandHint_tooltip_touch: "<p>Double-tap: unfold, one row per level.</p><p>Double-tap a row's 📖 to fold again.</p><p>Tap a letter to open that list.</p><p>Also: account menu ▸ Settings ▸ Word list settings.</p>",
	wlVerbCompactHint_tooltip_touch: "<p>Double-tap: fold the verb rows into one strip.</p><p>Double-tap the 📝 there to unfold.</p><p>Also: account menu ▸ Settings ▸ Word list settings.</p>",
	wlVerbExpandHint_tooltip_touch: "<p>Double-tap: unfold, one row per list.</p><p>Double-tap a row's icon to fold again.</p><p>Tap an icon to open that list.</p><p>Also: account menu ▸ Settings ▸ Word list settings.</p>",
	richTopicHint_tooltip_touch: "(tap to open this topic's word list)",
	knownToggle_tooltip_touch: "Mark this meaning as already known — exercises skip it (tap again to undo)",
	exGroup_recalled_tooltip_touch: "You produced these words to the standard you set yourself on the strictness level slider. Tap the words to see or change where that bar sits — it is the only thing deciding which group a word lands in.",
	exGroup_notRecalled_tooltip_touch: "These words did not come back to the standard you set yourself on the strictness level slider. Nothing is lost and no plant ever shrinks — they simply come back sooner. Tap the words to see or change where that bar sits.",
	garden_stats_click_hint_touch: "Tap for this word's statistics",
	garden_grow_open_touch: "Tap to see your whole garden",
	garden_thirsty_tooltip_touch: "Words due for watering<p/>Tap to put them in the practice tray",
	garden_vista_click_hint_touch: "Tap for its full entry",
	hist_tip_word_touch: "The word this row is about. Tap the row for its full learning history.",
	hist_ws_tip_word_touch: "The word this row is about. Tap the row for its full history.",
	hist_wh_tip_when_touch: "The session that drilled this word — its day and start time. Tap the row to open that session.",
	hist_acc_hard_sub_touch: "lowest accuracy, among words shown at least {0} times — tap a word for its full history",
	// ── end of the tap copy ──
	// The two faces of the ONE tooltip-size control, used in BOTH of its places: the square
	// glyph button in a large tooltip's bottom-right corner takes the "small" one as its
	// aria-label, and the "?" menu's row shows whichever one it is currently offering.
	// Write them as ACTIONS ("make…"), never as states — the row offers, it does not report.
	tipMakeSmall_label: "Make small tooltips",
	tipMakeLarge_label: "Make large tooltips",
	// ── Onboarding: the guided first session (js/onboarding.js) ──
	obWelcome_title: "Welcome!",
	obWelcomeLang_label: "I speak:",
	obLevelRow_label: "Your level:",
	obWelcomeBack_tooltip: "Back to the start page — to pick a different language",
	obWelcome_body: "A short guided tour: first you get to know a couple of words, then the Practice tab makes them stick. Just three minutes. No sign-up needed.",
	obLevel_label: "How much do you already know?",
	// {0} = the language being learned, named in the reader's language (lang_names)
	obLevelA_button: "Just starting to learn {0}",
	obLevelB_button: "I can hold a simple conversation",
	obLevelC_button: "I know it fairly well but want to expand my vocabulary",
	obMeet_button: "Quick guided tour",
	// …and the second line of that same button while the words are being fetched
	obMeet_loading: "Fetching your first words…",
	obExplore_button: "I'll explore on my own",
	obGotIt_button: "Got it",
	obBeatBed_title: "Planted!",
	obBeatBed_body: "Your words are in your garden now. They'll be thirsty tomorrow — come back and water them.",

	// ── Onboarding: the tour that follows the first finished drill (js/onboarding_guide.js) ──
	obTourProgress_title: "Your progress",
	obTourProgress_body: "This panel keeps score over time — words mastered, how accurate you are, how much you've studied.",
	obTourBack_title: "Done with this set",
	obTourBack_body: "Back to Words leaves the session and lets you pick what to study next.",
	obTourDict_title: "The dictionary",
	obTourDict_body: "Everything you can learn here has an entry — open the Dictionary.",
	// {0} = the language being learned, {1} = a word that IS in the dictionary
	obTourLookup_body: "Type a word you want to find in {0}, for example {1}, and press Enter.",
	obTourLookup_title: "Look a word up",
	obTourLookupPlain_body: "Type a word you want to find in {0} and press Enter.",
	obTourWlAdd_title: "Add it to a word list",
	obTourWlAdd_body: "Click this button and pick a list — the word goes straight into the one you choose. Word lists are how you collect exactly the words you want to learn and practice.",
	obTourMyList_title: "Your list",
	obTourMyList_body: "All the words and phrases you have added to your word list are here. Click it to open the list.",
	obTourRowAdd_title: "Take it to Learn",
	obTourRowAdd_body: "This button moves the word into your Learn tray, ready for the next session.",
	obTourBand_title: "Add a few more",
	obTourBand_body: "One word is a thin session — open the highlighted list, the one of your level, and add a handful of random words to learn together. Later you will be able to pick out individual words one by one as well.",
	obTourBandAdd_title: "The Add button",
	obTourBandAdd_body: "Every list has one: it moves words from the list into your tray. Click it.",
	obTourBandRandom_title: "Let the list pick",
	obTourBandRandom_body: "Random draws a mixed handful for you — the quickest way to fill a session.",
	obTourBandFive_title: "Take 5",
	obTourBandFive_body: "Click the small arrow beside 5 and five random words are picked.",
	obTourBandAppend_title: "Keep what you have",
	obTourBandAppend_body: "Your tray already holds a word. Choose the second option — it adds the new ones and keeps it.",
	// ── Onboarding: the Word Lists chapter (offered once the first half of the tour ends) ──
	obWlOffer_title: "Ready to learn",
	obWlOffer_body: "Now you are ready — click “Start Learning!” and learn your new words.\n\nBut before you move on, let me show you the Word Lists a little more closely. There is a lot to find there! You can also take the Word list tour later, from the help menu {?}.\n\nDo you want to continue the tour?",
	obWlOfferNo_button: "No, I'll continue on my own",
	obWlOfferYes_button: "Yes, please — show me the Word Lists",
	obWlPanel_title: "Your word lists",
	obWlPanel_body: "This panel is your library: ready-made lists drawn from the dictionary, and the lists you make yourself.",
	obWlGarden_title: "My Garden",
	obWlGarden_body: "Every word you have planted grows here, sorted by how well you know it. Click on My Garden to open it.",
	obWlGardenAuto_title: "It fills itself",
	obWlGardenAuto_body: "The words you are learning are added here automatically — you never have to add them yourself.",
	obWlLevels_title: "By usage frequency",
	obWlLevels_body: "All the dictionary words are split into lists by level, from the easiest to the hardest. Click a list to open it and see its words.",
	obWlTopics_title: "By topic",
	obWlTopicPick_body: "Eighteen lists behind a single row — food, travel, work, and the rest. Click the highlighted one to open it.",
	obWlTopicWord_title: "Straight to the entry",
	obWlTopicWord_body: "Click a word in any word list to see its dictionary entry. Try the highlighted one.",
	obWlFilter_title: "Find a word",
	obWlFilter_body: "Click on the magnifying glass to quickly find words in all your word lists.",
	obWlFilterBox_title: "Type to search",
	obWlFilterBox_body: "Type a few letters in the search field — they are looked for in every list at once, and the number beside a list is how many of its words match. Click the list to see them. Try a word from a lesson you've already finished: you'll likely find it in more than one list.",
	obWlMine_title: "My List",
	obWlMine_body: "⭐ A word you save from the dictionary goes to the list you pick — My List is here from the start, but you will be able to make lists of your own as well.",
	obWlNew_title: "Make your own",
	obWlNew_body: "Click this button to create a new word list — collect the words there by lesson, by song, by topic, however you like.",
	obWlNewName_title: "Name it",
	obWlNewName_body: "Type the name you like and hit Enter.",
	// {0} = the add-to-list icon, inline
	obWlNewUse_title: "Where it will show up",
	obWlNewUse_body: "Next time you click {0} on a word you want to keep, you will be able to send it to this list.",
	// ── Onboarding: the sign-off, said in the open help menu on every ending (chapter 4) ──
	obSignReplay_title: "Now it's your turn",
	obSignReplay_body: "<p>Look up any word, build your own lists, watch your garden grow. Most of all, type your words in Practice — recalling them yourself is what makes them stay.</p><p>Want this tour again? It's right here in the menu.</p>",

	obTourQuit_title: "Still on the tour",
	obTourQuit_body: "The other controls are asleep while the guided tour is running. Do you want to finish the tour and explore the application on your own? You can start the tour again at any time from the help menu {?}.",
	obTourQuitYes_button: "Yes, stop the tour",
	obTourQuitNo_button: "No, continue the tour",
	obTourQuitRestart_button: "Start the tour over",
	obBack_button: "Back",
	obContinue_button: "Continue",
	obDoorPractice_title: "Straight to Practice?",
	obDoorPractice_body: "Do you want to go directly to Practice? The tour will continue there.",
	obDoorPracticeStay_button: "No, stay in the Learn exercise",
	obDoorPracticeGo_button: "Yes, to Practice",
	obDoorDict_title: "Explore the Dictionary?",
	obDoorDict_body: "This will end the tour, but you'll be able to start it again at any time from the help menu {?}.",
	obDoorDictStay_button: "Back",
	obDoorDictGo_button: "Open the Dictionary",
	// The second line of every card button that carries a recommendation — the quit card's
	// "continue", the welcome card's "meet your first words", the Word Lists offer's "yes".
	obRecommended_hint: "(Recommended)",

	// ── Onboarding: the entry tour, on the first meet card (js/onboarding_guide.js) ──
	obMeetReveal_title: "Your first word",
	obMeetReveal_body: "Have a guess, then click the prompt — or press Enter — to see what it means.",
	obMeetEntry_title: "The whole word",
	obMeetEntry_body: "Every word you meet comes with a full dictionary entry — meanings, grammar, examples and pronunciation. The translation is at the top, everything else below.",
	// {0} = the meet card's own forward button
	obMeetGotIt_title: "Move on",
	obMeetGotIt_body: "Click “{0}” when you have finished reading.",
	obMeetNext_title: "Over to you",
	obMeetNext_body: "Just follow the instructions on screen to carry on learning your first couple of words with Parlevi.",

	// ── Onboarding: beacon tips (js/onboarding_tips.js) ──
	obTipExpLearn_title: "Start here",
	obTipExpLearn_body: "New words are met on the Learn tab. Grab a few from the word lists on the left to get going.",
	obTipExpStart_title: "Meet your words",
	obTipExpStart_body: "<p>Click Start Learning to meet your first couple of words — picked at random for your level for this first session. Later on you can choose any words you like yourself.</p><p>One more thing: while the tour runs, most of the app is deliberately out of reach, so nothing distracts from the simplest path. Once it ends, everything is yours to use.</p>",
	obTipExpDrill_title: "They're ready",
	obTipExpDrill_body: "Your words made it through. Take them to Practice — a short exercise makes them stick.",
	obTipExpList_title: "Open a word list",
	obTipExpList_body: "Click on this dictionary word list to open it.",
	obTipExpChip_body: "Click this letter to open the dictionary's easiest word list.",
	obTipExpAdd_title: "Add a few words",
	obTipExpAdd_body: "This button adds words from the open list to your learning tray — click it and pick how many.",
	obTipExpTray_title: "Your words are waiting",
	obTipExpTray_body: "The words you picked are in your tray on the Learn tab, ready when you are.",

	// ── Onboarding: the explore glow guide's menu steps (js/onboarding_guide.js) ──
	obGuideRandom_title: "Let the list pick",
	obGuideRandom_body: "Random draws a mixed handful of words for you — the quickest first scoop.",
	obGuideFive_title: "Take 3 to start",
	obGuideFive_body: "Click the small arrow and 3 random words land in your learning tray.",
	obGuideFiveNext_title: "Take 5 more",
	obGuideFiveNext_body: "Click the small arrow and 5 random words land in your learning tray.",
	obGuideDrill_title: "Drill them in",
	obGuideDrill_body: "Click Start Exercise! — a short timed drill makes these words stick.",
	// {0} = the language THIS card is answered in (it changes card by card in a Mix session).
	obGuideType_title: "Your turn",
	obGuideType_body: "Type the {0} translation here and press Enter.",
	// The monolingual pair (reader language == learned language): there is no translation to type,
	// the learner types the word itself, cued by its defining phrase.
	obGuideTypeWord_body: "Type the {0} word here and press Enter.",
	// No Space here: the caret lives in the answer field for the whole card, so the key types a
	// space (2026-08-10 rule). The speaker button is what replaced it.
	obTipSpacePron_title: "Hear it spoken",
	obTipSpacePron_body: "Click the speaker button to hear the word pronounced. It appears wherever the word can be heard.",
	obTipThirsty_title: "Watering time",
	obTipThirsty_body: "Some of your plants are thirsty. Click the chip to stage exactly those words for a quick watering round.",
	obTipDirection_title: "Switch direction",
	obTipDirection_body: "Answer in the language you're learning, in your own — or mix both in one session. The speaker button drills by ear.",
	obTipMyGarden_title: "Your garden lives here",
	obTipMyGarden_body: "Every word you've planted is in My Garden — growing, needing water, or in full bloom.",
	obTipAddPill_title: "Add more words",
	obTipAddPill_body: "Add moves words from this list into your tray. A handful at a time grows best.",
	obTipDictLookup_title: "Look anything up",
	obTipDictLookup_body: "Type any word in the language you're learning — meanings, examples and grammar included.",
	obTipGear_title: "Make it yours",
	obTipGear_body: "Session speed, repetitions, strictness level — tune your practice here.",

	// ── The help hub: the "?" in the tabs row (js/onboarding.js, spec §7) ──
	obHelpMenu_label: "Help",
	obHelpMenuTip_label: "Tip of the day",
	obHelpMenuAllTips_label: "All tips",
	obHelpMenuReplay_label: "Guided tour",
	obHelpMenuWlTour_label: "Word list tour",
	obHelpMenuWelcome_label: "Welcome screen",
	// The hub's one setting: guided MODE (tooltip-engine-consolidation.md §4.9). Its row has
	// no label key of its own — it shows tipMakeSmall_label / tipMakeLarge_label, the same two
	// strings the tooltip's corner button uses. NOT the tour's guided RUN.

	// ── Tip of the day (js/tips.js, docs/project/tip-of-the-day.md) ──
	tipDay_title: "Tip of the day",
	tipsAll_title: "All tips",
	tipsClose_label: "Close",
	// The interruption is what is switched off, not the tips — hence the toast naming where it
	// went, and hence the switch below saying what it turns back ON.
	tipsOff_toast: "Tips are off. Turn them back on in Help ▸ All tips.",
	tipsDaily_label: "Show a tip each day",
	tipsToday_label: "Today",
	// The tease line's speaker. No shortcut in the face, unlike sound_tooltip: Space belongs to
	// the word on the card behind this popup, and claiming it here would take it from there.
	tipTeaseSound_tooltip: "Listen to this line",

	// ── Learning mode (the Learn tab) ──
	learnEmpty_message: "Your learning tray is empty.",

	// The empty-tray quick-start block, shared by BOTH trays (js/main.js quickStartBlock).
	// {0} is the editable count and must stay positionable: the renderer splits the string on
	// it and injects the input element between the halves. The level button faces are NOT here
	// — they reuse the left panel's own wlLevel*_label strings, so a band is named the same in
	// both places. Design note: docs/project/learn-quick-start-tray.md.
	quickStart_line: "Grab some words from the Word Lists on the left — or quick-pick {0} random words right here:",
	quickStart_count_tooltip: "How many words each button adds",
	quickStart_exhausted_tooltip: "You've studied every word here — pick your own from the Word Lists on the left",

	learnStartButton_label: "Start Learning!",
	learnStartButton_tooltip: "Meet the new words gently — no timer, no pressure",
	learnClear_tooltip: "Empty the learning tray",
	learnRelearn_button: "Learn again",
	learnRelearn_tooltip: "Drill these ready words once more — the ladder starts over, their \"ready\" status stays",
	learnBackToTray_label: "← back to the words",
	learnGuided_dots: "Practice · 6 rounds per word",
	learnNew_badge: "new",
	learnRow_progress_tooltip: "Started earlier — the ladder resumes where it left off",
	learnStudyTerm_tooltip: "Click to open the full dictionary entry for this word",
	learnMeet_reveal_label: "Do you know the translation? Click here or press Enter to reveal it",
	learnMeet_gotIt_label: "Got it →",
	learnMeet_fromVerb_label: "from the verb",
	learnQ_meaning: "What does it mean?",
	learnQ_pickWord: "Pick the word for:",
	learnQ_lookalike: "Look closely — which word means:",
	learnQ_whoWhen: "Who, and when?",
	learnQ_whoWhenHint: "the pronoun is left out on purpose — the ending says who",
	learnOpt_none: "None of these",
	learnNone_taught: "Right — the word wasn't among them.",
	learnQ_phraseMeaning: "What does {0} mean here?",
	learnQ_pickPhrase: "Pick the phrase for:",
	learnQ_pickGap: "Which word completes it?",
	learnQ_typeGapHint: "type the first {0} letters of the missing word — it will finish itself",
	learnQ_typeFullGapHint: "type just the missing word — a second slip on a letter reveals it",
	learnQ_start: "How does it start?",
	learnQ_typeHint: "type the first {0} letters — the word will finish itself",
	learnQ_letterHint: "hint: it starts with {0}",
	learnQ_letterHintSubst: "hint: it starts with {0} — typing “{1}” works too",
	learnQ_hearHint: "hint: listen — here's the word",
	learnQ_change: "What changes?",
	learnQ_changeHint: "type the part that changes in each form",
	learnQ_typeFull: "Now type the whole word",
	learnQ_typeFullHint: "type it from memory — a second slip on a letter reveals it",
	learnQ_repeatWord: "Repeat the word",
	learnQ_hear: "What did you hear?",
	learnQ_pickHint: "Click the correct card or type its number",
	learnFeedback_correct: "Correct!",
	learnFeedback_wrong: "Not quite",
	learnFeedback_retry: "you will have another try",
	learnMiss_settling: "Still settling — we'll come back to it in a moment.",
	learnMiss_continue: "Continue →",
	learnSpace_tooltip: "Enter",
	learnReady_toast: "{0} is ready for the drill",
	learnRecap_head: "{0} new words met",
	learnRecap_met: "words met",
	learnRecap_ready: "ready for the drill",
	learnRecap_time: "time",
	learnRecap_bridge: "They'll wait for you in the Practice tray — the drill burns them in for good.",
	learnRecap_drillNow: "Go to Practice now! →",
	learnRecap_back: "Back to Learn",
	learnNudge_message: "Brand-new words here: {0} — a first look in Learn makes the drill feel very different.",
	learnNudge_action: "Learn them first",
	learnError_message: "The learning session could not start",

	proceed: "Proceed?",
	error: "An error occurred, sorry.\nPlease try reloading the page",
	stopButton_tooltip: "Click to stop the exercise and return to the main page",
	langTo_tooltip: "Select the language you want to study",
	langFrom_tooltip: "Select your own language or a language you know",
	// The browser tab, rebuilt when the learned language changes without a reload. MUST stay word
	// for word the same as main.meta.title in this locale's global properties — the server renders
	// the title once, this rewrites it, and the two must not disagree. {0} = the learned language
	// as this reader's language writes it, {1} = the brand.
	browserTitle_main: "Learn {0} — {1}",
	// The two flag slots of the language panel — same words as the rows they stand next to
	// (main.label.knowLang / main.label.learnLang), which is what they were saying in
	// hardcoded English before PR 7/7 of the tooltip engine put them on PL.tip.
	// The English dialect chooser under the "I'm learning" value. The tooltip is the only place
	// the choice explains itself — the buttons carry no caption — so it names all three things it
	// changes rather than just "American English".
	enDialectUs_tooltip: "American English — the voice you hear, the transcription that leads, and the accent you are scored against",
	enDialectUk_tooltip: "British English — the voice you hear, the transcription that leads, and the accent you are scored against",
	operationCannotComplete_message: "Operation cannot be completed",

	myList_create_tooltip: "Create a new word list",
	// ── Dictionary direction: the DE⇄EN toggle and the reverse (EN → DE) hit list ──
	// {0} = the language the typed word is expected to be in. Both directions are as-you-type: the
	// forward seek walks the German dictionary, the reverse one walks the tape of English keys
	// (design §9). Enter then focuses the one word, which is what "press Enter" used to mean here.
	lookupField_placeholder_forward: "Start typing a word in {0} to find its entry",
	lookupField_placeholder_reverse: "Start typing a word in {0} to find the words that mean it",
	dictDir_forward_tooltip: "Look up a word in {0} — the language you are learning (Alt+1)",
	dictDir_reverse_tooltip: "Look up a word in {0} — find the {1} words that mean it (Alt+2)",
	reverse_intro_message: "Start typing a word in {0} to see the {1} words that mean it.",
	// Shown for the seconds after a restart while the pair's index is still building — every
	// dictionary surface (both tapes and the focused lookup) says the same thing, and each retries
	// on its own, so this is a wait and not a dead end.
	dict_notReady_message: "The dictionary is still loading — one moment…",
	// The flag + language code are prepended as markup, so these carry only the tail: "🇬🇧 EN" + …
	reverse_head_one: "word · 1 match",
	reverse_head_many: "word · {0} matches",
	reverse_empty_message: "No entry for “{0}”",
	reverse_fallback_message: "No entry for “{0}” — showing results for",
	reverse_seeAlso_label: "see also:",
	reverse_phrases_label: "In phrases ({0})",
	reverse_phrases_shown: "Showing the first {0} of {1}",
	// ── The collocation search band under the A–Z rows (forward dictionary only). The two labels
	// are rendered as small caps by CSS and get " · <count>" appended, so they carry no count
	// placeholder themselves.
	phraseBand_words_label: "In words",
	phraseBand_collocations_label: "In collocations",
	phraseBand_examples_label: "In examples",
	phraseBand_myPhrases_label: "From phrases I typed",
	phraseBand_noEntry_message: "No dictionary entry for “{0}”",
	phraseBand_stripOpen_tooltip: "Show what was found",
	phraseBand_stripClose_tooltip: "Hide these results",
	phraseBand_pagerFirst_tooltip: "Back to the first row",
	phraseBand_pagerPrev_tooltip: "Back {0} rows — hold to keep going",
	phraseBand_pagerNext_tooltip: "On {0} rows — hold to keep going",
	phraseBand_pagerLast_tooltip: "To the last rows",
	phraseBand_pagerRow_tooltip: "Rows {0}–{1} of {2} — click to jump",
	// The wrong-toggle nudge: shown INSTEAD of generating an entry, when the typed word is not a
	// word of the language being learned but is a known meaning in the learner's own language.
	dict_wrongDirection_message: "“{0}” looks like a word in {1}.",
	dict_wrongDirection_switch: "Look it up {0} → {1}",
	dict_wrongDirection_anyway: "No — look it up in {0}",
	// R13 "Enter opens the match": the quiet strip under a card Enter opened for a DIFFERENT
	// headword than what was typed — {0} in the message is the OPENED word, {0} in the link is
	// what was TYPED (main.js openMatchStrip).
	dict_openMatch_prefix_message: "Did you mean “{0}”?",
	dict_openMatch_corrected_message: "Showing “{0}”.",
	dict_openMatch_lookup_link: "Look up “{0}” instead",
	startButton_label: "Start Exercise!",
	startButton_tooltip: "Click to start learning words!",
	startButton_noWords_message: "There were no words selected for the exercise.\nOpen a word list on the left and use \"Add to Practice\".",
	// connection.js's banner (docs/project/restart-notice-and-resend.md) and the start refusal
	// while an update runs.
	connUpdating: "Parlevi is restarting. Please wait a minute.",
	connLost: "Connection lost. Your answers are saved and will be sent when it's back.",
	connNoNewExercise: "Parlevi is restarting. Please try again in a minute.",
	revealWord_label: "Reveal the word",
	revealWord_tooltip: "Show the answer for this word",
	startButton_wordsInExercise: "Words for an exercise:",
	// ── Practice direction cluster (the Start band's arrow pair + mix bracket + speaker) ──
	// The button faces are built from the language codes ("EN → DE") and are NOT translatable;
	// these carry the task phrasing. {0} = the language whose words get typed.
	practiceDir_forward_tooltip: "You see the meaning — type the word in {0}<p/>[both directions pressed = mix]",
	practiceDir_reverse_tooltip: "You see the word — type what it means in {0}<p/>[both directions pressed = mix]",
	practiceDir_mix_label: "mix",
	practiceDir_mix_tooltip: "Click both directions for a mixed session: every word goes the way it did NOT go last time<p/>(the set stays the same length — one card per word)",
	practiceDir_mixOff_tooltip: "A mixed session needs whole-word practice (one card per word)",
	practiceDir_audio_tooltip: "Cue by ear: hear the word instead of reading the meaning<p/>Combines with either direction",
	practiceDir_locked_tooltip: "This is the direction the running exercise uses<p/>Stop the exercise to change it",
	// Combined tray view only: distinct words vs total drillable senses ({0} = words, {1} = meanings).
	trayCount_wordsAndMeanings: "{0} words · {1} meanings",
	number_of_words_remaining: "The number of words remaining in the current exercise",
	pauseButton_label: "Pause Exercise",
	pauseButton_tooltip: "Click to pause learning words",
	continueButton_label: "Resume Exercise",
	continueButton_tooltip: "Click to continue learning words",
	practiceAgainButton_label: "Practice Again!",
	practiceAgainButton_tooltip: "Run the same set again — the words should flow first-try now",
	backToWordsButton_label: "Back to Words",
	backToWordsButton_sub: "choose a new set",
	stopButton_label: "Stop Exercise",
	stopButton_sub: "(and return to main page)",
	undo_label: "Undo",
	// The message box's only button (js/msgbox.js). English-only on purpose: getRes falls back
	// to this file, and "OK" is the value in every one of the six locales (see i18n/global*.properties).
	msgOk_button: "OK",
	clearTray_button: "Clear",
	clearTray_tooltip: "Clear the practice tray<p/>(Undo restores it)",
	// The ⊙ button next to Clear, and the line that heads the screen it reopens.
	lastFinish_label: "Last practice session",
	lastFinish_tooltip: "Show the last finished practice screen again",
	trayCapped_message: "A tray holds at most {0} words — trimmed to {2} of {1}. Drill those first, then add the rest.",
	practiceEmpty_message: "Your practice tray is empty.",
	noWords_message: "Sorry, but we don't have any words for this selection yet",
	chooseLangTo_label: "Choose…",
	chooseLangTo_message: "Choose a language to learn",
	noData_message: "No data returned from the server",
	wlLabel: "Word Lists",
	// The add picker's own heading and its create row. An add control carries NO tooltip: hovering
	// it opens this picker, which names every destination there is
	// (docs/project/wl-add-target-redesign.md).
	wlAddPick_label: "Add to…",
	wlAddPickNew_label: "New list…",
	richTerm_tooltip: "Click to collapse — or press Esc / the browser's Back button to exit this view",
	revealTerm_tooltip: "Click to open the dictionary entry — Esc comes back to the card",
	richEmpty_none: "No dictionary entry for this one yet.",
	richEmpty_failed: "The dictionary entry could not be loaded. Check your connection and try again.",
	sound_tooltip: "Sound<p/>[Shortcut: Space]",

	// Pronunciation practice (docs/project/ai-features-plan.md §1). The mic stands beside every
	// speaker; its popup is where a learner speaks and reads back what came of it.
	pronMic_tooltip: "Practice saying it<p/>Opens the practice card — hold the microphone there and speak",
	pronHold_tooltip: "Hold and speak, release when you are done",
	pronClose_tooltip: "Close",
	pronBest_label: "best",
	// The two dials: would a listener recover your words, and how close is the sound to native.
	// The labels have to carry that on their own — a tooltip nobody opens is not an explanation.
	pronDialRecognition_label: "Understood",
	pronDialAccent_label: "Native-like",
	pronDialLegend_label: "outer ring = this attempt · centre = your best",
	pronDialRecLast_tooltip: "This attempt — how much of what you said a listener would recover: {0}",
	pronDialRecBest_tooltip: "Your best here for being understood: {0}",
	pronDialAccLast_tooltip: "This attempt — how close the sound was to a native speaker: {0}",
	pronDialAccBest_tooltip: "Your best here for native sound: {0}",
	pronDialNone_tooltip: "Nothing said here yet",
	pronDialNoBest_tooltip: "No best recorded yet",
	pronDialPlay_hint: "click to hear it",
	pronNoRecording_message: "No recording — your voice is kept only until the page is closed.",
	pronHint_hold: "hold to talk — release when done",
	pronHint_recording: "listening…",
	pronHint_scoring: "scoring…",
	pronSoundedLike_tip: "sounded like /{0}/ where /{1}/ belongs",
	pronOmitted_tip: "this word was not heard",
	// The diagnosis layer: a red dial always names its culprit.
	pronDiagHeard_text: "heard: “{0}”",
	// The average ear's own transcript — it was never told what was coming, so when it disagrees
	// with the script-primed one this is the line that explains the dial.
	pronDiagEarHeard_text: "a listener who did not know what to expect heard: “{0}”",
	// The middle band of the two-ear score, in one sentence. What happened and the constraint —
	// no advice about what to do next (docs/feedback/ui-copy-no-unsolicited-advice.md).
	pronDiagPatient_text: "a patient listener understands you here; an average one struggles",
	pronDiagMissed_text: "did not come through: {0}",
	pronDiagSilence_text: "nothing was heard in this recording",
	pronDiagSound_text: "weakest sound: /{0}/ in “{1}”",
	pronDiagSoundOnly_text: "weakest sound: /{0}/",
	pronDiagPart_text: "weakest part: “{0}” in “{1}”",
	pronDiagPartOnly_text: "weakest part: “{0}”",
	pronDiagWord_text: "weakest word: “{0}”",
	// The demoted dimension row: the sentence a number can justify, never the number.
	pronExpPartial_text: "part of it was not said",
	pronExpPauses_text: "long pauses between the words",
	pronExpFlat_text: "the melody stayed flat",
	pronSilent_message: "That recording is silent. The microphone may be muted or off.",
	pronNoMic_message: "This browser cannot reach a microphone here.",
	// Refusals: what happened and the constraint, then stop.
	pronRefusalCap_message: "This week's practice allowance is used up. It refills a week after each attempt.",
	pronRefusalUnavailable_message: "Pronunciation scoring is not available for this language.",
	pronRefusalAudio_message: "Nothing was heard in that recording.",
	pronRefusalNoWord_message: "This word is no longer in the dictionary.",
	pronRefusalProvider_message: "Scoring did not come back this time.",
	hist_wh_chart_spoken: "Pronunciation",
	hist_wh_tip_chart_spoken: "Every time you said this word out loud. A dot per attempt, scored on its weakest sound; the line is your best so far.",
	wlLoad_error_message: "Cannot load your word lists",
	wlDelete_error_message: "Cannot delete the word list",
	wlRename_tooltip: "Rename this word list",
	wlDelete_tooltip: "Delete this word list",
	wlNoWords_message: "No words are selected",
	wlDeleteWords_tooltip: "Delete selected words from this word list",
	wlCopyWords_tooltip: "Copy selected words to another word list",
	wlCopyNoLists_message: "You have only one word list — create another one first, then copy the selected words into it",
	wlDeleteWords_error_message: "Cannot delete words from the word list",
	wlCannotLoadWords_error_message: "Cannot load words for the word list",
	wlCannotDeleteWord_error_message: "Cannot delete the word from the word list",
	wlCopyWords_error_message: "Cannot copy the words to another word list",
	wlAddNoWordList_error_message: "Cannot add the word to a word list — no word list is selected",
	wlAdd_error_message: "Cannot add the word to a word list",
	wlVerbs_label: "Verb forms",
	wlVerbs_tooltip: "Irregular verbs, drilled as one card per verb — all its forms together",
	wlConjugation_label: "Conjugation",
	wlConjugation_tooltip: "Verbs, drilled one conjugated form at a time",
	wlVerbsNoForms_message: "No forms could be prepared for that verb",
	wlVerbsTruncated_message: "Added the first {0} of {1} verbs — add the rest in another go",
	wlVerbsExpand_error_message: "Cannot prepare the verb forms",
	wlTypedPhrases_label: "Phrases I typed",
	wlTypedPhrases_tooltip: "Phrases you have typed that are not in our dictionary yet — visible only to you. New ones land here automatically",
	wlTypedRemove_tooltip: "Remove from this record — copies in your lists stay",
	wlGarden_label: "My Garden",
	wlDefault_label: "My List",
	wlGarden_tooltip: "Every word you have actually touched — what needs watering, what you started, and what is growing<p/>Click the flower to see the whole garden",
	// The two faces of the watering badge on the My Garden row (main.js paintGardenWaterBadge).
	wlGardenNeedsWater_tooltip: "{0} words are overdue for watering<p/>Open My Garden to see them",
	wlGardenWatered_tooltip: "Nothing needs watering right now — your whole garden is up to date",
	wlGardenDifficult_label: "Difficult words",
	wlGardenWatering_label: "Needs watering",
	wlGardenProgress_label: "Learning",
	wlGardenReady_label: "Ready for practice",
	wlGardenGrowing_label: "Growing",
	wlGardenSetAside_label: "Set aside",
	// Section tooltips: the FULL name (the band itself may be clipped to "READY FOR P…" in a
	// narrow panel) plus what the band actually means.
	wlGardenDifficult_tooltip: "Words that are giving you a hard time — drill each on 3 different days and it leaves this list",
	wlGardenWatering_tooltip: "These words are overdue — water them now to keep them growing",
	wlGardenProgress_tooltip: "You have started these words in Learn but not finished them yet",
	wlGardenReady_tooltip: "These words have been learned already, now they need practice",
	wlGardenGrowing_tooltip: "These words are planted and not due yet — the badge counts the days to their next practice",
	wlGardenSetAside_tooltip: "Words you have set aside — they rest here, keeping everything they have learned, until you wake them",
	wlGardenEmpty_message: "Nothing here yet — learn or practice a word and it appears in your garden",
	wlGardenSecEmpty_tooltip: "Nothing in this section right now",
	wlGardenContinueLearn_label: "Continue in Learn",
	wlGardenAll_disabled_tooltip: "Too many words to add at once (max {0}) — use Random instead",
	wlGardenUseSections_note: "Each section means something different — add from a section's own header.",
	wlLevelA_label: "Elementary",
	wlLevelB_label: "Beginner",
	wlLevelC_label: "Intermediate",
	wlLevelD_label: "Advanced",
	wlLevelE_label: "Expert",
	wlLevelA_tooltip: "The 1,000 most frequent words · ≈ CEFR A1",
	wlLevelB_tooltip: "Words 1,001–4,000 · ≈ CEFR A2",
	wlLevelC_tooltip: "Words 4,001–12,000 · ≈ CEFR B1",
	wlLevelD_tooltip: "Words 12,001–24,000 · ≈ CEFR B2",
	wlLevelE_tooltip: "Beyond the top 24,000 words · ≈ CEFR C1–C2",
	// CEFR band slots (label-driven languages — EN since the C2 switch). Labels are the CEFR
	// codes themselves, international across locales; tooltips carry the official one-line
	// descriptor, C2+ with one extra clause for the beyond-CEFR tail.
	wlLevelA1_label: "A1",
	wlLevelA2_label: "A2",
	wlLevelB1_label: "B1",
	wlLevelB2_label: "B2",
	wlLevelC1_label: "C1",
	wlLevelC2P_label: "C2+",
	wlLevelA1_tooltip: "CEFR level A1: understand and use familiar everyday expressions and very basic phrases",
	wlLevelA2_tooltip: "CEFR level A2: understand frequent expressions about everyday matters — family, shopping, work, surroundings",
	wlLevelB1_tooltip: "CEFR level B1: follow the main points of clear standard speech and text on familiar matters",
	wlLevelB2_tooltip: "CEFR level B2: understand the main ideas of complex text and interact with a degree of fluency",
	wlLevelC1_tooltip: "CEFR level C1: understand a wide range of demanding, longer texts and use language flexibly",
	wlLevelC2P_tooltip: "CEFR level C2: understand with ease virtually everything heard or read — plus rarer and more specialized words beyond the CEFR ladder",
	// The plain-language name of each CEFR band. The A–E frequency scheme labels its bands with
	// words already ("Elementary", "Advanced"); the CEFR scheme labels them with the bare code,
	// which is the international name and has to stay — but which explains nothing to a learner
	// who has never met the ladder (owner report 2026-08-25: the empty tray's A1/A2/B1 buttons
	// read as nothing at all). These names ship WITH the code, never instead of it: the quick-pick
	// button carries them under its code, the Word Lists rows after theirs, and a folded level
	// chip leads its tooltip with one. Only the CEFR slots have them — see levelPlainName().
	wlLevelA1_name: "Beginner",
	wlLevelA2_name: "Elementary",
	wlLevelB1_name: "Intermediate",
	wlLevelB2_name: "Upper-Intermed.",
	wlLevelC1_name: "Advanced",
	wlLevelC2P_name: "Mastery",
	wlLevelSortAlpha_label: "Alphabetical",
	wlLevelSortFreq_label: "By usage frequency",
	wlLevelSort_tooltip: "How this list is ordered — click to switch",
	// The four fold hints. Several POINTS, so they are written as <p> and the tip engine puts air
	// between them (css/components/tooltip.css); each one leads with the double-click, because that
	// is the gesture on the very icon being hovered, and names the menu route last.
	wlLevelCompactHint_tooltip: "<p>Double-click: fold the level rows into one strip.</p><p>Double-click the 📖 there to unfold.</p><p>Also: account menu ▸ Settings ▸ Word list settings.</p>",
	wlLevelExpandHint_tooltip: "<p>Double-click: unfold, one row per level.</p><p>Double-click a row's 📖 to fold again.</p><p>Click a letter to open that list.</p><p>Also: account menu ▸ Settings ▸ Word list settings.</p>",
	wlLevelStripCount_tooltip: "Words in the dictionary for this language pair",
	wlVerbCompactHint_tooltip: "<p>Double-click: fold the verb rows into one strip.</p><p>Double-click the 📝 there to unfold.</p><p>Also: account menu ▸ Settings ▸ Word list settings.</p>",
	wlVerbExpandHint_tooltip: "<p>Double-click: unfold, one row per list.</p><p>Double-click a row's icon to fold again.</p><p>Click an icon to open that list.</p><p>Also: account menu ▸ Settings ▸ Word list settings.</p>",
	wlVerbStripCount_tooltip: "Verbs on both lists for this language pair",
	// 🗂️ Topics — one panel row standing for the eighteen by-situation lists.
	wlTopics_label: "Topics",
	wlTopics_tooltip: "The dictionary by situation — pick a topic to open its word list",
	wlTopicsPick_label: "Pick a topic",
	wlTopicsEmpty_message: "No topics for this language pair yet",
	// A topic chip's hover hint — the bold name goes above it (topicChipTooltipHtml, main.js).
	richTopicHint_tooltip: "(click to open this topic's word list)",
	// The taxonomy itself. Keyed off Topic.messageKey() (TRAVEL -> topic_travel_label): adding or
	// renaming a topic means the enum, the classification prompt and these five bundles. The badge
	// emoji is NOT here — it is language-independent and lives on the enum.
	topic_study_label: "Study & Education",
	topic_travel_label: "Travel & Transport",
	topic_food_label: "Food & Drink",
	topic_health_label: "Health & Body",
	topic_sport_label: "Sport",
	topic_fashion_label: "Fashion & Appearance",
	topic_family_label: "Family & Relationships",
	topic_work_label: "Work & Career",
	topic_politics_label: "Politics & Society",
	topic_home_label: "Home & Household",
	topic_money_label: "Shopping & Money",
	topic_nature_label: "Nature, Weather & Environment",
	topic_animals_label: "Animals",
	topic_tech_label: "Technology & Internet",
	topic_media_label: "Media & Communication",
	topic_culture_label: "Culture & Entertainment",
	topic_feelings_label: "Emotions & Character",
	topic_law_label: "Law & Crime",
	wlAddPractice_button: "Add to Practice",
	wlAddLearn_button: "Add to Learning",
	wlAddMenuHeader_label: "Add words to the Practice tray",
	wlAddMenuHeaderLearn_label: "Add words to the Learning tray",
	wlMenuAll_label: "All",
	wlMenuMax_label: "Max ({0} first)",
	wlMenuSelected_label: "Selected",
	wlMenuRandom_label: "Random",
	wlMenuCountEdit_tooltip: "Change the number of words",
	// Replace-or-add, asked at the end of a bulk pick when the destination tray already holds words.
	// {0} in the labels is the TRAY'S NAME — "Practice" or "Learn", read from the tab strip and
	// picked out in the accent colour; the _math strings carry the arithmetic beside it.
	trayReplace_label: "Replace in the {0} Tray",
	trayAppend_label: "Add to the {0} Tray",
	trayReplace_math: "(−{0} : +{1})",              // {0} lost, {1} gained
	trayAppend_math: "({0} + {1} → {2})",           // staged + gained → total
	trayReplace_tooltip: "Throw away the {0} words already staged and drill these {1} instead",
	trayAppend_tooltip: "Keep the {0} words already staged and add these {1} — {2} in all",
	// The append row's OTHER two shapes. "up to" is used when the client cannot see which words the
	// pick contains (a collapsed or half-scrolled list, a filtered one, a Random draw the server has
	// not made yet), so the overlap with the tray — and therefore the total — is unknown. Quoting a
	// total anyway is what produced "41 + 41 → 82" over a tray already holding all 41.
	trayAppendUpTo_math: "({0} + up to {1})",       // staged + at most this many new
	trayAppendUpTo_tooltip: "Keep the {0} words already staged and add up to {1} more"
		+ " — any that are already in the tray will not be added twice",
	trayNothingNew_tooltip: "All {0} of these are already in the tray — there is nothing to add",
	// A Verbs pick brings conjugated forms, several cards per verb, counted only once the server
	// expands them — so those two rows carry no arithmetic and say why.
	trayReplaceVerbs_tooltip: "Throw away what is staged and drill these verb forms instead"
		+ " (each verb becomes several cards, so the count is known once they are expanded)",
	trayAppendVerbs_tooltip: "Keep what is staged and add these verb forms to it"
		+ " (each verb becomes several cards, so the count is known once they are expanded)",
	trayFull_tooltip: "The tray already holds its maximum of {0} words — replace it, or clear some first",
	// Fallback only: the labels normally take the tray's name from the tab strip itself.
	trayDest_practice: "Practice",
	trayDest_learn: "Learn",
	// One-press tray buttons (docs/project/tray-add-buttons.md) — Add on a dict row/rich card/
	// popup/phrase; Move on a tray row's OPPOSITE-tray button.
	trayAddLearn_tooltip: "Add to Learn",
	trayAddPractice_tooltip: "Add to Practice",
	trayMoveLearn_tooltip: "Move to Learn",
	trayMovePractice_tooltip: "Move to Practice",
	// A press that adds nothing because the words are already staged. {0} is the tray's name. The
	// tray is NOT repainted for this — the toast is the whole answer, so it must never be silent.
	trayAlreadyStaged_toast: "Already in the {0} tray",
	wlMove_label: "Move to…",
	wlCopy_label: "Copy to…",
	wlSelected_label: "selected",
	wlEmptyList_message: "No words here yet — add words from the Dictionary or other word lists",
	wlNewListPlaceholder: "New list name…",
	wlFilterPlaceholder: "Filter words…",
	wlxGlobalFilter_placeholder: "Find a word in all lists…",
	wlxGlobalFilter_tooltip: "Search across all word lists",
	wlNoMatch_message: "No words match the filter",
	wlCheckAll_tooltip: "Select all words",
	wlGardenSecCheckAll_tooltip: "Select every word in this section",
	wlWordCount_tooltip: "Number of words in this list",
	wlRowPractice_tooltip: "Add this word to the Practice tray",
	wlRowLearn_tooltip: "Add this word to the Learning tray",
	wlRowMoveCopy_tooltip: "Move or copy this word to another word list",
	wlRowRemove_tooltip: "Remove this word from the list",
	wlRowPark_tooltip: "Set this word aside — it stops coming up for practice and keeps everything it has learned, until you wake it. You will find it in My Garden, in the 'Set aside' band at the bottom",
	wlRowWake_tooltip: "Wake this word — it goes back into practice from where it left off",
	wlRowUnmarkDifficult_tooltip: "Take this word out of Difficult words",
	wlRowDifficultMarks_tooltip: "Practiced on {0} of {1} days — drill it on {1} different days and it leaves this list",
	wlRowDifficultHeld_tooltip: "Practiced on {0} days — the three days are earned, but the last practice still singled this word out. It leaves after the first one that does not.",
	wlRowDifficultStuck_tooltip: "Practiced on {0} days and still being singled out — this one may need re-learning rather than more drilling. Set it aside, or keep going: it leaves after the first practice that does not single it out.",
	wlRowParkFailed_error_message: "Cannot set this word aside",
	trayParkNotStarted_message: "This word has not been practiced yet, so there is nothing to set aside — just remove it from the tray",
	trayRemove_tooltip: "Remove this word from the tray",

	// ── Scroll pager: the scroll bars' aria-labels (js/scroll_pager.js — no tooltip: hovering
	//    one of these controls scrolls, so a popup would cover the rows it just set moving) ──
	scrollUp_tooltip: "Scroll up",
	scrollDown_tooltip: "Scroll down",

	knownToggle_tooltip: "Mark this meaning as already known — exercises skip it (click again to undo)",
	wlSort_tooltip: "Sort your lists (the word lists you created yourself)",
	wlSortNewest_label: "Newest first",
	wlSortOldest_label: "Oldest first",
	wlSortAlpha_label: "Alphabetical",
	wlSortSize_label: "By size",
	wlBasket_tooltip: "Recently deleted lists (Recycle Bin)",
	wlBasketTitle_label: "Recently deleted",
	wlBasketEmpty_button: "Delete all forever",
	wlBasketEmpty_message: "The basket is empty",
	wlRestore_button: "Restore",
	wlRestore_tooltip: "Restore this list",
	wlDeleteForever_tooltip: "Delete permanently — this cannot be undone",
	tzDetected_text: "Detected",
	settingsTimeZone_tooltip: "Detected from your browser — everything the app calls \"today\" is counted on this clock.<p>Change it only if it is wrong, or if you want to keep your home calendar while travelling.",
	settingsDayStart_tooltip: "When your day rolls over.<p>At the default 03:00 a session at 1am still counts as the evening before — practicing late must not cost you a streak — and the review after a night's sleep is the next day. Set 00:00 for a plain midnight.",
	signupOptional_tooltip: "Registration is optional.<p> But if you register, your personal word lists and settings will be kept for you and available from any computer",
	tsVerbForms_hint: "irregular verb — {0} forms",
	// The reverse cue on a conjugated-form card: the form is on screen, and what is asked for is the
	// VERB it is a form of — any of its meanings, since a paradigm cell has no meaning of its own
	// (docs/project/conj-card-and-answer-matching.md §3).
	tsWhichVerb_question: "Which verb is this?",
	tsWhichVerb_hint: "(any of the verb's meanings will do)",
	tsListToSound: "Listen — then type the {0} translation",
	tsWordNotRetrieved: "Couldn't load the words",
	tsAnswerNotSet: "Couldn't set up the answer",
	tsYouDoneIt: "Great job!",
	tsCounterIsZero: "Counter is zero",
	tsWrong: "Not quite correct",
	//Caption under the reveal diff. The row above it is the BEST attempt of this showing, which
	//may not be the text left in the field — say so, or the panel looks like it diffed the wrong try.
	tsBestAttempt_label: "your best attempt",
	//Wrong-answer tier phrases (wrong_feedback.js): tier 1 = way off ... tier 5 = almost right.
	//Encouragement only — must never hint at WHAT is wrong.
	tsWrongT1_1: "Yeah, it's a tough one… take your time",
	tsWrongT1_2: "A hard one — no rush",
	tsWrongT1_3: "Tricky word — stay with it",
	tsWrongT2_1: "Not yet — keep going",
	tsWrongT2_2: "Give it another try",
	tsWrongT2_3: "You'll get this one",
	tsWrongT3_1: "Getting warmer",
	tsWrongT3_2: "You're on the right track",
	tsWrongT3_3: "Coming along — keep at it",
	tsWrongT4_1: "Close!",
	tsWrongT4_2: "Nearly there!",
	tsWrongT4_3: "Not far off!",
	tsWrongT5_1: "Almost there!",
	tsWrongT5_2: "So close!",
	tsWrongT5_3: "Ooh — right on the edge!",
	// No shortcut named on purpose: in the drill the caret lives in the answer field, where Space is
	// a space — the button is the way to replay (see training_session.js cueSoundButton).
	tsSound_tooltip: "Listen",
	tsReady_tip: "Place the cursor here and press Enter to get the next word in the exercise",
	tsSelfKnow: "I understand",
	tsSelfDontKnow: "I don't understand",
	tsSelfRight: "I was correct",
	tsSelfWrong: "I got it wrong",
	tsTypeTranslation_tip: "Type the correct {0} translation here",
	// Monolingual pair — see obGuideTypeWord_body.
	tsTypeWord_tip: "Type the correct {0} word here",
	tsDefinitionWasNotSet: "Could not get the definition of the word",
	settings_tooltip: "Settings",
	// ── Practice settings dialog (#dlgPrefId): one explanation per row, shown by the delegate in
	// user_attr.js off the row's data-tip-key (main.html). The four Answers rows also carry a
	// data-tip-off-key — the line appended while updateReverseDependents (main.js) has the row
	// greyed, so the greying says why. {0}/{1} in the Adaptive speed line are the live
	// learn.exercise.* tuning values (exercise_tuning), not restated defaults.
	prefSpeed_tooltip: "How fast the countdown runs while you type. Longer answers get more time; 1 is unhurried, 10 is a sprint.<p>A word you miss gets extra time on its next showing.",
	prefAdaptiveSpeed_tooltip: "Within a session, each correct answer on a word makes its next showing a little faster — {0}% per step, up to {1} steps — and a miss steps it back. A word's first showing always runs at the normal speed.",
	prefStrictCaps_tooltip: "Capital letters count: the answer has to match the word's capitalisation exactly. Off, upper and lower case are treated the same.",
	prefDrillArticle_tooltip: "A noun is only right with its article: <i>der Kunde</i>, not just <i>Kunde</i>. The article is part of the word, so it is part of what you type. Off, you type the bare noun.",
	prefSelfCheck_tooltip: "When you see the word and are asked for its meaning, you answer in your head instead of typing — say whether you understand it, see the answer, then say whether you were right. Off, you type the meaning.",
	prefGapPhrases_tooltip: "A sentence is shown with its key word missing, and that word is all you type. Off, you type the whole sentence.<p>Short phrases are always typed in full — their exact wording is the point.",
	prefStrictness_tooltip: "How much proof a word needs to count as passed and grow in your garden. Left: typed from memory after a look at the answer, or close enough, and sessions stay short. Right: typed exactly before the countdown ends, more than once.<p>The line under the slider spells out the notch you are on.",
	prefVerbOnlyIrregular_tooltip: "The Conjugation list keeps only the irregular verbs — the ones whose forms have to be learned one by one. Off, it lists every verb, regular ones too.",
	prefVerbFullParadigm_tooltip: "A verb added from the Conjugation list brings its whole table — six tenses in six persons, 36 forms. Off, it brings eight key forms: present <i>ich, du, er, wir</i>; perfect <i>ich, er</i>; past <i>ich, du</i>.",
	prefVerbPronounPrefill_tooltip: "On a conjugation card the pronoun is already in place in front of the answer field and you type only the verb form: <i>ich</i> is given, <i>fahre</i> is typed. Off, you type the pronoun too.",
	prefTypedRowOff_tooltip: "Not in use in this direction: here you answer with the meaning, not with the word you are learning.",
	prefSelfCheckOff_tooltip: "Not in use in this direction: here you type the word you are learning, so there is nothing to self-check.",
	ai_unknownWord_error: '"{0}" is not a {1} word we know.',
	ai_disabled_error: 'AI lookup is currently unavailable.',
	ai_signIn_error: 'Sign in to look up new words today.',
	audio_signIn_message: 'Sign in to keep hearing new words.',
	phraseTooLong_message: "That's a bit too long for our dictionary — the limit is 8 words, 80 characters total.",
	rich_loading_message: 'Looking up…',
	rich_failed_message: 'Lookup failed. Please try again.',
	// The two lines under the head of a freshly minted card, while the rest of the entry is built
	// behind the reader (docs/project/live-mint-async-build-plan.md §3 B5). Neither is an error:
	// the translation above them is the answer to what was asked.
	rich_enriching_message: 'The full entry is being prepared…',
	rich_enrichFailed_message: 'Only the translation is ready for this word.',
	stats_panel_title: 'My Progress',
	stats_scope_tooltip: 'Everything you have studied in {0}. Every session counts, whichever language its hints were written in.',
	stats_label_mastered: 'words mastered',
	stats_label_accuracy: 'accuracy',
	stats_label_sessions: 'sessions',
	stats_label_studied: 'studied',
	stats_streak: '{0}-day streak',
	stats_best_streak: 'best {0}',
	stats_today: 'Today: {0} words · {1}',
	stats_coverage: '{0} of the top {1} words',
	stats_seen: '{0} words seen',
	stats_learning: '{0} in progress',
	exSummary_flawless: 'flawless',
	exSummary_time: 'session time',
	exSummary_speed: 'typical answer',
	exSummary_tricky: 'Difficult words this session — do you want to add them to the Difficult words list?',
	exSummary_offerDifficult_tooltip: "Add to Difficult words in My Garden",
	exSummary_difficultGraduated: "Not difficult anymore! 🎉",
	exSummary_difficultProgress: "Good progress on the difficult words!",
	exSummary_difficultFiled: "Added to Difficult words:",
	exSummary_difficultFiled_shown: "— the answer was shown {0} times",
	exSummary_difficultFiled_shownFew: "— the answer was shown {0} times",
	phrasePick_tooltip: "Drill it in phrases — pick a few real sentences with this word",
	phrasePickTitle_label: "“{0}” in phrases",
	phrasePickAdd_label: "Add to drill",
	phrasePickDrop_tooltip: "Leave this one out",
	phrasePickRestore_tooltip: "Put this one back",
	phrasePickNone_message: "No phrases left to add for “{0}” — either none are stored yet, or you already have them all.",
	phrasePickAdded_message: "Added to your drill.",
	exSummary_bridgeMastered: '{0} words mastered in total',
	exOutcome_recalledCold: 'recalled cold',
	exOutcome_knownSlow: 'known — slow recall',
	exOutcome_knownArticle: 'known — article shaky, the word itself is there',
	exOutcome_warmUp: 'needed a warm-up',
	exOutcome_relearned: 'needed the answer shown — coming back sooner',
	exOutcome_earlyPractice: 'watered a little — full growth when it\'s due',
	exOutcome_practiced: 'practiced — growth comes when it\'s due',
	// ── what each of those phrases MEASURED, on its own hover ──────────────────────────────
	// All eight describe the FIRST showing of the word in this session, which is the only one
	// scored. Say what happened; do not tell the learner what to do about it.
	exOutcome_recalledCold_tooltip: 'First showing, right answer, straight away and with no help.',
	exOutcome_knownSlow_tooltip: 'The word came back, just slower than this word usually takes you. It counts as knowing it.',
	exOutcome_knownArticle_tooltip: 'The noun came back; the article did not. The drill asked again, but the word itself counts as recalled.',
	exOutcome_warmUp_tooltip: 'Not clean on the first try — a small slip, or an answer that arrived after the moment that counts as instant recall. It still counts as a recall, not a miss.',
	exOutcome_relearned_tooltip: 'The answer had to be shown before this word came back. It is scheduled sooner than it would have been.',
	exOutcome_earlyPractice_tooltip: 'You practiced this before its watering day. It counts, but the plant takes its step on the date the badge shows — practicing early does not bring it forward.',
	// v2 copy — same string, restated for the growth-v2 rule (garden-srs-redesign-spec.md Sec 2/§7;
	// garden-srs-implementation-plan.md "what is still open" item 6): growth is a FIXED proof-ladder
	// mark the word must be practiced at, or just before, never a model estimate crossing a milestone
	// — and the badge above shows the next WATERING day, not the growth mark: two different clocks.
	// Picked at render time by main.js's exOutcomeTipKey(), which reads GARDEN.isGrowthV2Mode() — the
	// same signal garden.js's explainer already uses, never a second mechanism. Reachable only once
	// learn.srs.growth.mode is active AND this session's growth-v2 fetch has resolved — see
	// docs/project/garden-growth-explainer.md's "v2 copy" section for the full audit. The other seven
	// exOutcome_*_tooltip keys describe the practice outcome only, name no growth trigger, and stay
	// correct under either rule — they were checked and deliberately left alone.
	exOutcome_earlyPractice_tooltip_v2: 'You practiced this before its watering day. It counts, but the plant\'s next growth mark is a fixed day on its own calendar, not the date the badge shows — only a pass at, or just before, that mark claims it.',
	exOutcome_practiced_tooltip: 'You had already practiced this word today. A second run on the same day is not counted as a new repetition — the next step comes at the next watering.',
	// The finish screen's two word sections. "Still growing" is deliberately not "not promoted":
	// holding a stage until the word is due IS the healthy common case, not a failure.
	exSummary_grewToday: 'Grew today ({0})',
	exSummary_stillGrowing: 'Still growing ({0})',
	// The two section heads' own hovers. Both carry the same rule from opposite sides, because it
	// is the question this card raises first: a plant grows when the estimate of how long you would
	// still remember the word passes the next mark — not because the answer was right.
	exSummary_grewToday_tooltip: 'These words moved up a stage today — the arrow shows the step. A plant grows when the estimate of how long you would still remember the word passes the next mark: 1, 3, 7, 14, 30, 60 or 90 days.',
	exSummary_stillGrowing_tooltip: 'These words were watered but kept their stage, which is the ordinary case. The number in front of each word is the next watering, and it usually moves further out even when the picture stays the same. The plant changes only when the estimate passes the next mark: 1, 3, 7, 14, 30, 60 or 90 days.',
	// The heading those two share for the moment before the server has scored the session — see
	// renderWordSections. It names the only thing known then: which words were drilled.
	exSummary_sessionWords: 'This session\'s words ({0})',
	exSummary_sessionWords_tooltip: 'Every word this session drilled. What grew and what held its stage appears a moment later, once the session is scored.',
	garden_grow_title: 'Today\'s growth',
	// The same bed when nothing grew — it still holds every word the session drilled, so it is
	// named for what it honestly is rather than claiming growth that did not happen.
	garden_bed_session: 'This session\'s words',
	garden_not_planted: 'Not planted yet',
	garden_grow_next: 'next watering in {0}',
	// ── the watering schedule, on the day badge's own tooltip ──────────────────────────────
	// {0} is always a day count (GARDEN.humanizeDays) — never "~3 weeks". The badge beside the
	// tooltip prints that exact number, and the two must not disagree on one screen.
	garden_water_next: 'Water this word again in {0} — that is what the number says. Practising it sooner does not grow the plant any faster.',
	garden_water_today: 'Due today — this word is ready for watering. The dot stays blank until it is a full day late.',
	garden_water_overdue: 'Overdue by {0} — this word is thirsty. Nothing is lost: the plant never shrinks, it just comes back sooner.',
	// P6 garden growth v2 surfaces (buckets, sprout, soft next-mark words, decision moment)
	garden_sprout_stage_name: 'Sprout',

	// The growth ladder's eight rungs (garden.js). Were hardcoded English literals in the
	// code until 2026-09-01 — i18n-runtime-grammar.md Sec 7.
	garden_ready_stage_name: "Ready",
	garden_stage1_name: "Seen once",
	garden_stage2_name: "Recognised",
	garden_stage3_name: "Recalled",
	garden_stage4_name: "Taking root",
	garden_stage5_name: "Rooted",
	garden_stage6_name: "Known",
	garden_stage7_name: "Mastered",
	// The next GROWTH mark, in soft words, appended to the watering badge's tooltip. Five spans
	// since 2026-08-25 (was three): everything past a fortnight used to collapse into "further
	// out", so 30 days and 90 days read the same and "not due to grow yet" looked like a repeated
	// non-answer. Words, never digits — that is what keeps this inside R38's "soft words only".
	// garden.js's SOFT_MARK_SPANS holds the cutoffs (3 / 14 / 45 / 75 days).
	garden_nextMark_fewDays: 'Next growth check-in: in a few days.',
	garden_nextMark_twoWeeks: 'Next growth check-in: in about two weeks.',
	garden_nextMark_month: 'Next growth check-in: in about a month.',
	garden_nextMark_twoMonths: 'Next growth check-in: in about two months.',
	garden_nextMark_fewMonths: 'Next growth check-in: in a few months.',
	// ── the finish screen's three word groups (docs/project/finish-screen-classification.md) ──────
	// ONE axis: the verdict at the user's own strictness notch. The four R13 buckets are still what
	// the server sends and still decide the split INSIDE "Recalled"; they stopped being group names
	// because "Will grow soon" / "Needs sooner watering" describe what the app did, which the user
	// can check and disagree with, while the group is a claim about what they remembered.
	//
	// {1} in the two verdict heads is the linked word — main.js's exStrictnessHead splits the
	// formatted string there and drops an <a> in. Keep {1} in any translation, and inflect
	// exGroup_strictnessWord to match the case the sentence puts it in.
	exGroup_firstWatering: 'First watering ({0})',
	// The one celebratory line on this card (owner, 2026-08-25). Deliberately says nothing about
	// pass or fail: a first practice is a first meeting, so there was nothing to recall yet.
	exGroup_firstWatering_note: 'Congratulations — your first watering! These shoots have taken root and started to grow.',
	exGroup_firstWatering_tooltip: 'The first time you practice a word, its shoot becomes a real plant: it takes a place in the watering schedule and starts working towards its first growth mark. Nothing is judged here — a first practice is a first meeting, not a test of remembering.',
	exGroup_recalled: 'Recalled — at your {1} ({0})',
	exGroup_recalled_tooltip: 'You produced these words to the standard you set yourself on the strictness level slider. Click the words to see or change where that bar sits — it is the only thing deciding which group a word lands in.',
	exGroup_notDueYet: 'The flower is not due to grow yet ({0})',
	exGroup_notDueYet_tooltip: 'These words came back, and their flower simply has no growth mark due yet. The ordinary case, not a shortfall: a plant grows when it reaches its own next mark — 1, 3, 7, 14, 30, 60 or 90 days — never because one more answer was right.',
	exGroup_notRecalled: 'Not recalled — at your {1} ({0})',
	exGroup_notRecalled_tooltip: 'These words did not come back to the standard you set yourself on the strictness level slider. Nothing is lost and no plant ever shrinks — they simply come back sooner. Click the words to see or change where that bar sits.',
	exGroup_strictnessWord: 'strictness level',
	exBucket_grew: 'Grew today ({0})',
	exBucket_grew_tooltip: 'These words reached their next growth mark today — a fixed day on their own calendar, earned by a real practice at or after it opens, never by a model\'s estimate.',
	exBucket_multiStage: 'climbed more than one stage at once',
	decisionMoment_pileUp: 'A lot is coming due this week compared to your recent pace. You could give sessions a bit more time, ease the strictness level a notch, or slow down adding new words.',
	decisionMoment_headroom: 'Your practice load is light compared to your recent pace — there\'s room to add more words, tighten the strictness level a notch, or simply keep going as you are.',
	// The three forms of "day". English needs two; Russian picks by the count (день / дня / дней),
	// which is why the count chooses the key rather than the string carrying a plural rule.
	garden_day_one: 'day',
	garden_day_few: 'days',
	garden_day_many: 'days',
	// On the plant's hover peek, wherever the plant is a door into that word's statistics.
	garden_stats_click_hint: 'Click for this word\'s statistics',
	// Conjugation rows only: the plant there is the WEAKEST of the verb's drilled forms, so the peek
	// has to say how many forms that one stands for. Shown from 2 upward — a single form needs no count.
	garden_forms_growing: '{0} forms growing',
	garden_grow_from: 'grew from {0}',
	garden_grow_open: 'Click to see your whole garden',
	garden_vista_title: 'My Garden',
	garden_vista_count: '{0} words planted',
	garden_vista_empty: 'Nothing planted yet — practice a word and its first shoot appears here.',
	garden_sr_edu: '💡 Watering twice a day doesn\'t speed growth — plants need time between waterings.',
	garden_thirsty_chip: '{0} thirsty',
	garden_thirsty_tooltip: 'Words due for watering<p/>Click to put them in the practice tray',
	// Shown on EVERY press of the chip, not only when something new landed: a press that added
	// nothing (they were all staged already) used to answer with silence and read as a broken
	// button. The sentence is true either way, and it answers the question the press was asking.
	garden_thirstyStaged_toast: 'All the thirsty plants are in the tray, ready to be watered!',
	garden_open_btn: 'My Garden',
	garden_open_tooltip: 'Your whole word garden — every word you\'ve planted, at its current stage',
	garden_vista_click_hint: 'Click for its full entry',
	// ── "How does my garden grow?" — the one explainer panel (docs/project/garden-growth-explainer.md)
	// Every number here is the M5 milestone ladder read out loud (1+3+7+14+30+60 ≈ 115 days), so no
	// other surface may quote a different one. A few keys carry inline <em>/<b> — the panel renders
	// them with .html(), the same way the garden's tooltips already carry <p/>.
	// ⚠️ This is the v1 / flag-off story. Once learn.srs.growth.mode is active, garden.js's
	// openGrowthGuide() swaps the ladder graphic AND (as of this v2-copy pass) lead/how/closing below
	// for their _v2 siblings via v2GuideMode + guideKey() — see garden_guide_lead_v2's comment for the
	// numbers and docs/project/garden-growth-explainer.md's "v2 copy" section for the full picture.
	// twoThings/hurryHead/hurryBody/forgetHead/forgetBody/ladder_note/firstplant_card make no claim
	// that changes under v2 (checked, deliberately left as the single copy for both rules).
	garden_guide_title: 'How does my garden grow?',
	garden_guide_open_chip: 'How does my garden grow?',
	// Under the ladder. The rungs count from the START, so this line is what stops "~4 months"
	// under the flower from reading as a promise.
	garden_guide_ladder_note: 'Counting from your first practice, with every watering on time.',
	// The first rung is the only one the picture cannot explain by itself: every other rung is a
	// plant that GREW, while "Ready" is a graduated word with no user_term_garden row at all
	// (GardenService.termStatus) — no stage, no schedule, nothing counting, which is why its wait
	// column reads "—" rather than a number. It is NOT "no plant": a Ready word already draws the
	// germination shoot (plantSvg "germ" → g-ready-body) in the vista, in word-list rows and on
	// this very ladder, so the first wording contradicted the picture beside it (owner, same day:
	// "we do show a small plant even after Learn session"). Said in the app's own existing words
	// for that state (the word lists' "Ready for practice" band: "these words have been learned
	// already, now they need practice"), so the two surfaces name one thing the same way.
	garden_guide_ready_note: 'The first step, “Ready”, is a word you have learned but not practiced yet: the shoot is already showing, but nothing is scheduled and nothing is counting until its first practice.',
	garden_guide_lead: 'If you take good care of it — about half a year. The fastest it can be done is around four months.',
	// v2 copy (see the exOutcome_earlyPractice_tooltip_v2 comment above for the gating mechanism) —
	// the numbers change because the ladder itself changes: v1's marks are M5-estimate crossings
	// (≈115 days fastest, garden.js GUIDE_WAIT_DAYS); v2's are the fixed proof ladder
	// {1,3,7,14,30,60,90}d (GUIDE_WAIT_DAYS_V2), all-on-time total 205 days ≈ seven months, with the
	// spec's own "~7-9 months to full bloom" (garden-srs-redesign-spec.md Sec 2) for the typical case.
	garden_guide_lead_v2: 'If you take good care of it — around seven to nine months, typically. The fastest it can be done, watering right on time every step, is about seven months.',
	garden_guide_how: 'Your plant grows one step each time you water it <em>when it asks</em> and still remember the word. The waits between waterings start tiny and stretch as the word takes root: a day, a few days, a week, two weeks, a month, two months. The glowing halo is the final step, and it means one thing: this word survived a couple of months on its own and you still knew it. Those waits add up to about four months even for a word that comes to you effortlessly — and around six for a normal one. A stubborn word takes as long as it takes; the app will keep working on it with you.',
	// v2 copy — seeded from Round 33's owner-approved "why these intervals" answer
	// (docs/project/garden-growth-rules-redesign.md, R33): doubling steps, honest speakable
	// checkpoints, watering and growth are separate clocks. "A quarter" is the new top gap (90d,
	// stage 6 to 7) — v1's top gap read "a couple of months" (60d) because that ladder was one rung
	// shorter.
	garden_guide_how_v2: 'Your plant grows a step only when its own growth mark comes due — <em>not just because you watered it</em>. Memory strengthens in roughly doubling steps: each time you can still recall a word after a longer break, the next break can safely be about twice as long, so the marks climb a day, three days, a week, two weeks, a month, two months, a quarter. A pass shortly before a mark still claims it — the window is short, but it exists. The glowing halo is the final step, and it means one thing: this word survived a full quarter on its own and you still knew it. Those marks add up to about seven months even for a word that clears every one right on time — and seven to nine for a normal one, since a mark you miss simply waits for your next good pass rather than costing the word anything. A stubborn word takes as long as it takes; the app will keep working on it with you.',
	garden_guide_twoThings: 'Two things worth knowing:',
	garden_guide_hurryHead: 'You can\'t hurry it by watering more.',
	garden_guide_hurryBody: 'Practicing a word ten extra times today doesn\'t grow anything — the app already knows you remember it <em>today</em>. What it\'s waiting to see is whether you remember it next week, and next month. Memory grows in the gaps, and the plant honestly shows that.',
	garden_guide_forgetHead: 'Forgetting is not a disaster.',
	garden_guide_forgetBody: 'If a word slips away, the plant never shrinks — it just gets thirsty 💧, comes back sooner, and you rebuild from where you were.',
	garden_guide_closing: 'So: plant it, water it when it asks, and expect the halo in about a season or two. It can\'t be rushed — and that\'s exactly why it means something. A glowing flower isn\'t a badge for tapping buttons; it\'s the app telling you: <em>this word is yours now, for good.</em>',
	// v2 copy — only the timeframe changes (a season ≈ 3 months; v2's total runs longer than v1's).
	garden_guide_closing_v2: 'So: plant it, water it when it asks, and expect the halo in two or three seasons. It can\'t be rushed — and that\'s exactly why it means something. A glowing flower isn\'t a badge for tapping buttons; it\'s the app telling you: <em>this word is yours now, for good.</em>',
	// The one-time card on the finish screen of the session that planted the user's first word.
	garden_firstplant_card: 'Your first word just sprouted 🌱 — see how it grows into the glowing flower.',
	conj_tense_present: 'Present',
	conj_tense_past: 'Past (Preterite)',
	conj_tense_perfect: 'Perfect',
	conj_tense_past_perfect: 'Past perfect',
	conj_tense_future: 'Future',
	conj_tense_conditional: 'Conditional (would)',
	// Chip tooltip: the German textbook term + the tense in the viewer's own words (owner,
	// 2026-08-28). The German half used to sit ON the face ("Präteritum · Past"); it moved here
	// because the face only needs what disambiguates — which tense — and the learner-language
	// name alone carries that.
	conj_tense_present_tip: 'Präsens / present tense',
	conj_tense_past_tip: 'Präteritum / simple past',
	conj_tense_perfect_tip: 'Perfekt / present perfect',
	conj_tense_past_perfect_tip: 'Plusquamperfekt / past perfect',
	conj_tense_future_tip: 'Futur / future tense',
	conj_tense_conditional_tip: 'Konjunktiv II / conditional (would)',
	// ── The Spanish conjugation panel (F2a, 2026-09-08) ──────────────────────────────────
	// The nine stored TAMs of register §2.5 plus the RENDERED negative imperative, which is
	// no + the present subjunctive and is never stored. The panel heads its columns with the
	// SPANISH name (Util.paradigmPack.ES in main.js), exactly as the German table heads its
	// own with Präsens; these are the learner-language names — the chip on a card, and the
	// header's hover tip.
	conj_tense_es_pres_ind: 'Present',
	conj_tense_es_pret_ind: 'Preterite',
	conj_tense_es_imp_aff: 'Imperative',
	conj_tense_es_imp_neg: 'Negative imperative',
	conj_tense_es_imperf_ind: 'Imperfect',
	conj_tense_es_fut_ind: 'Future',
	conj_tense_es_cond: 'Conditional',
	conj_tense_es_pres_subj: 'Present subjunctive',
	conj_tense_es_imperf_subj_ra: 'Imperfect subjunctive (-ra)',
	conj_tense_es_imperf_subj_se: 'Imperfect subjunctive (-se)',
	conj_tense_es_pres_ind_tip: 'presente / present tense',
	conj_tense_es_pret_ind_tip: 'pretérito indefinido / completed past',
	conj_tense_es_imp_aff_tip: 'imperativo / commands',
	conj_tense_es_imp_neg_tip: 'imperativo negativo / no + present subjunctive',
	conj_tense_es_imperf_ind_tip: 'pretérito imperfecto / ongoing or habitual past',
	conj_tense_es_fut_ind_tip: 'futuro simple / future tense',
	conj_tense_es_cond_tip: 'condicional / the would-form',
	conj_tense_es_pres_subj_tip: 'presente de subjuntivo / present subjunctive',
	conj_tense_es_imperf_subj_ra_tip: 'imperfecto de subjuntivo / past subjunctive, the usual form',
	conj_tense_es_imperf_subj_se_tip: 'imperfecto de subjuntivo / past subjunctive, the -se variant',
	// ── The Spanish FORM KINDS (F2b, 2026-09-08) ─────────────────────────────────────────
	// 77 kinds — 49 simple finite cells, 6 affirmative imperatives, 4 non-finite, 4 nominal,
	// 6 adjectival, 1 derived, 7 determiner/numeral — reached through PosLabel.CANON, exactly
	// like the German block above. ⭐ The _label is the SAME compact code in every bundle: a
	// finite cell names a tense AND a person, which no language abbreviates in five characters,
	// so the chip is Spanish-derived (pr2pl, ra3sg, ip1pl) and the _tooltip is the learner's.
	// Written by analytics/i18n/add_es_form_kind_keys.py — the tense halves are asserted equal
	// to the panel's own conj_tense_es_* values, so one screen never names a tense two ways.
	posVerbPresInd1Sg_label: 'pr1sg',
	posVerbPresInd1Sg_tooltip: 'Present, 1st person singular (yo)',
	posVerbPresInd2SgTu_label: 'pr2sg',
	posVerbPresInd2SgTu_tooltip: 'Present, 2nd person singular (tú)',
	posVerbPresInd2SgVos_label: 'prvos',
	posVerbPresInd2SgVos_tooltip: 'Present, 2nd person singular, voseo (vos)',
	posVerbPresInd3Sg_label: 'pr3sg',
	posVerbPresInd3Sg_tooltip: 'Present, 3rd person singular (él, ella, usted)',
	posVerbPresInd1Pl_label: 'pr1pl',
	posVerbPresInd1Pl_tooltip: 'Present, 1st person plural (nosotros)',
	posVerbPresInd2PlVosotros_label: 'pr2pl',
	posVerbPresInd2PlVosotros_tooltip: 'Present, 2nd person plural, Spain (vosotros)',
	posVerbPresInd3Pl_label: 'pr3pl',
	posVerbPresInd3Pl_tooltip: 'Present, 3rd person plural (ellos, ellas, ustedes)',
	posVerbPretInd1Sg_label: 'pt1sg',
	posVerbPretInd1Sg_tooltip: 'Preterite, 1st person singular (yo)',
	posVerbPretInd2SgTu_label: 'pt2sg',
	posVerbPretInd2SgTu_tooltip: 'Preterite, 2nd person singular (tú)',
	posVerbPretInd3Sg_label: 'pt3sg',
	posVerbPretInd3Sg_tooltip: 'Preterite, 3rd person singular (él, ella, usted)',
	posVerbPretInd1Pl_label: 'pt1pl',
	posVerbPretInd1Pl_tooltip: 'Preterite, 1st person plural (nosotros)',
	posVerbPretInd2PlVosotros_label: 'pt2pl',
	posVerbPretInd2PlVosotros_tooltip: 'Preterite, 2nd person plural, Spain (vosotros)',
	posVerbPretInd3Pl_label: 'pt3pl',
	posVerbPretInd3Pl_tooltip: 'Preterite, 3rd person plural (ellos, ellas, ustedes)',
	posVerbImperfInd1Sg_label: 'im1sg',
	posVerbImperfInd1Sg_tooltip: 'Imperfect, 1st person singular (yo)',
	posVerbImperfInd2SgTu_label: 'im2sg',
	posVerbImperfInd2SgTu_tooltip: 'Imperfect, 2nd person singular (tú)',
	posVerbImperfInd3Sg_label: 'im3sg',
	posVerbImperfInd3Sg_tooltip: 'Imperfect, 3rd person singular (él, ella, usted)',
	posVerbImperfInd1Pl_label: 'im1pl',
	posVerbImperfInd1Pl_tooltip: 'Imperfect, 1st person plural (nosotros)',
	posVerbImperfInd2PlVosotros_label: 'im2pl',
	posVerbImperfInd2PlVosotros_tooltip: 'Imperfect, 2nd person plural, Spain (vosotros)',
	posVerbImperfInd3Pl_label: 'im3pl',
	posVerbImperfInd3Pl_tooltip: 'Imperfect, 3rd person plural (ellos, ellas, ustedes)',
	posVerbFutInd1Sg_label: 'fu1sg',
	posVerbFutInd1Sg_tooltip: 'Future, 1st person singular (yo)',
	posVerbFutInd2SgTu_label: 'fu2sg',
	posVerbFutInd2SgTu_tooltip: 'Future, 2nd person singular (tú)',
	posVerbFutInd3Sg_label: 'fu3sg',
	posVerbFutInd3Sg_tooltip: 'Future, 3rd person singular (él, ella, usted)',
	posVerbFutInd1Pl_label: 'fu1pl',
	posVerbFutInd1Pl_tooltip: 'Future, 1st person plural (nosotros)',
	posVerbFutInd2PlVosotros_label: 'fu2pl',
	posVerbFutInd2PlVosotros_tooltip: 'Future, 2nd person plural, Spain (vosotros)',
	posVerbFutInd3Pl_label: 'fu3pl',
	posVerbFutInd3Pl_tooltip: 'Future, 3rd person plural (ellos, ellas, ustedes)',
	posVerbCond1Sg_label: 'co1sg',
	posVerbCond1Sg_tooltip: 'Conditional, 1st person singular (yo)',
	posVerbCond2SgTu_label: 'co2sg',
	posVerbCond2SgTu_tooltip: 'Conditional, 2nd person singular (tú)',
	posVerbCond3Sg_label: 'co3sg',
	posVerbCond3Sg_tooltip: 'Conditional, 3rd person singular (él, ella, usted)',
	posVerbCond1Pl_label: 'co1pl',
	posVerbCond1Pl_tooltip: 'Conditional, 1st person plural (nosotros)',
	posVerbCond2PlVosotros_label: 'co2pl',
	posVerbCond2PlVosotros_tooltip: 'Conditional, 2nd person plural, Spain (vosotros)',
	posVerbCond3Pl_label: 'co3pl',
	posVerbCond3Pl_tooltip: 'Conditional, 3rd person plural (ellos, ellas, ustedes)',
	posVerbPresSubj1Sg_label: 'sb1sg',
	posVerbPresSubj1Sg_tooltip: 'Present subjunctive, 1st person singular (yo)',
	posVerbPresSubj2SgTu_label: 'sb2sg',
	posVerbPresSubj2SgTu_tooltip: 'Present subjunctive, 2nd person singular (tú)',
	posVerbPresSubj3Sg_label: 'sb3sg',
	posVerbPresSubj3Sg_tooltip: 'Present subjunctive, 3rd person singular (él, ella, usted)',
	posVerbPresSubj1Pl_label: 'sb1pl',
	posVerbPresSubj1Pl_tooltip: 'Present subjunctive, 1st person plural (nosotros)',
	posVerbPresSubj2PlVosotros_label: 'sb2pl',
	posVerbPresSubj2PlVosotros_tooltip: 'Present subjunctive, 2nd person plural, Spain (vosotros)',
	posVerbPresSubj3Pl_label: 'sb3pl',
	posVerbPresSubj3Pl_tooltip: 'Present subjunctive, 3rd person plural (ellos, ellas, ustedes)',
	posVerbImperfSubjRa1Sg_label: 'ra1sg',
	posVerbImperfSubjRa1Sg_tooltip: 'Imperfect subjunctive (-ra), 1st person singular (yo)',
	posVerbImperfSubjRa2SgTu_label: 'ra2sg',
	posVerbImperfSubjRa2SgTu_tooltip: 'Imperfect subjunctive (-ra), 2nd person singular (tú)',
	posVerbImperfSubjRa3Sg_label: 'ra3sg',
	posVerbImperfSubjRa3Sg_tooltip: 'Imperfect subjunctive (-ra), 3rd person singular (él, ella, usted)',
	posVerbImperfSubjRa1Pl_label: 'ra1pl',
	posVerbImperfSubjRa1Pl_tooltip: 'Imperfect subjunctive (-ra), 1st person plural (nosotros)',
	posVerbImperfSubjRa2PlVosotros_label: 'ra2pl',
	posVerbImperfSubjRa2PlVosotros_tooltip: 'Imperfect subjunctive (-ra), 2nd person plural, Spain (vosotros)',
	posVerbImperfSubjRa3Pl_label: 'ra3pl',
	posVerbImperfSubjRa3Pl_tooltip: 'Imperfect subjunctive (-ra), 3rd person plural (ellos, ellas, ustedes)',
	posVerbImperfSubjSe1Sg_label: 'se1sg',
	posVerbImperfSubjSe1Sg_tooltip: 'Imperfect subjunctive (-se), 1st person singular (yo)',
	posVerbImperfSubjSe2SgTu_label: 'se2sg',
	posVerbImperfSubjSe2SgTu_tooltip: 'Imperfect subjunctive (-se), 2nd person singular (tú)',
	posVerbImperfSubjSe3Sg_label: 'se3sg',
	posVerbImperfSubjSe3Sg_tooltip: 'Imperfect subjunctive (-se), 3rd person singular (él, ella, usted)',
	posVerbImperfSubjSe1Pl_label: 'se1pl',
	posVerbImperfSubjSe1Pl_tooltip: 'Imperfect subjunctive (-se), 1st person plural (nosotros)',
	posVerbImperfSubjSe2PlVosotros_label: 'se2pl',
	posVerbImperfSubjSe2PlVosotros_tooltip: 'Imperfect subjunctive (-se), 2nd person plural, Spain (vosotros)',
	posVerbImperfSubjSe3Pl_label: 'se3pl',
	posVerbImperfSubjSe3Pl_tooltip: 'Imperfect subjunctive (-se), 3rd person plural (ellos, ellas, ustedes)',
	posImpAff2SgTu_label: 'ip2sg',
	posImpAff2SgTu_tooltip: 'Imperative, 2nd person singular (tú)',
	posImpAff2SgVos_label: 'ipvos',
	posImpAff2SgVos_tooltip: 'Imperative, 2nd person singular, voseo (vos)',
	posImpAff3SgUsted_label: 'ip3sg',
	posImpAff3SgUsted_tooltip: 'Imperative, 3rd person singular (usted)',
	posImpAff1Pl_label: 'ip1pl',
	posImpAff1Pl_tooltip: 'Imperative, 1st person plural (nosotros)',
	posImpAff2PlVosotros_label: 'ip2pl',
	posImpAff2PlVosotros_tooltip: 'Imperative, 2nd person plural, Spain (vosotros)',
	posImpAff3PlUstedes_label: 'ip3pl',
	posImpAff3PlUstedes_tooltip: 'Imperative, 3rd person plural (ustedes)',
	posInfinitive_label: 'inf',
	posInfinitive_tooltip: 'infinitive',
	posGerund_label: 'ger',
	posGerund_tooltip: 'gerund (-ando / -iendo)',
	posParticiple_label: 'part',
	posParticiple_tooltip: 'past participle',
	posParticipleAlt_label: 'part2',
	posParticipleAlt_tooltip: 'past participle, the second form',
	posNounPlural_label: 'pl',
	posNounPlural_tooltip: 'plural',
	posNounFeminineSg_label: 'fsg',
	posNounFeminineSg_tooltip: 'feminine singular, noun',
	posNounFemininePl_label: 'fpl',
	posNounFemininePl_tooltip: 'feminine plural, noun',
	posNounMascPlOfFemHead_label: 'mpl',
	posNounMascPlOfFemHead_tooltip: 'masculine plural of a feminine headword',
	posAdjFemSg_label: 'fsg',
	posAdjFemSg_tooltip: 'feminine singular, adjective',
	posAdjMascPl_label: 'mpl',
	posAdjMascPl_tooltip: 'masculine plural, adjective',
	posAdjFemPl_label: 'fpl',
	posAdjFemPl_tooltip: 'feminine plural, adjective',
	posAdjApocope_label: 'apoc',
	posAdjApocope_tooltip: 'shortened before a noun (gran, buen)',
	posAdjSuperlativoAbsoluto_label: 'sup',
	posAdjSuperlativoAbsoluto_tooltip: 'absolute superlative (-ísimo)',
	posAdjSuperlativoAbsolutoAlt_label: 'sup2',
	posAdjSuperlativoAbsolutoAlt_tooltip: 'absolute superlative, the second form',
	posAdvMente_label: 'adv',
	posAdvMente_tooltip: 'adverb in -mente',
	posDetFemSg_label: 'fsg',
	posDetFemSg_tooltip: 'feminine singular, determiner',
	posDetMascPl_label: 'mpl',
	posDetMascPl_tooltip: 'masculine plural, determiner',
	posDetFemPl_label: 'fpl',
	posDetFemPl_tooltip: 'feminine plural, determiner',
	posDetNeuter_label: 'neut',
	posDetNeuter_tooltip: 'neuter form (lo, esto)',
	posDetApocope_label: 'apoc',
	posDetApocope_tooltip: 'shortened before a noun',
	posNumFeminine_label: 'fem',
	posNumFeminine_tooltip: 'feminine numeral (una, doscientas)',
	posNumApocope_label: 'napo',
	posNumApocope_tooltip: 'shortened numeral (un, cien)',
	// The grammatical person a drilled conjugation cell sits in, shown as a chip beside the tense.
	// Kept to an abbreviation because it sits in a chip next to the tense one; the pattern is the
	// conventional dictionary abbreviation of each locale.
	conj_person_firstSg: '1st pers. sg.',
	conj_person_secondSg: '2nd pers. sg.',
	conj_person_thirdSg: '3rd pers. sg.',
	conj_person_firstPl: '1st pers. pl.',
	conj_person_secondPl: '2nd pers. pl.',
	conj_person_thirdPl: '3rd pers. pl.',
	rich_perfect_tooltip: "Perfect tense — how this verb forms its perfect: 'hat …' with haben, 'ist …' with sein",

	// ── Rule F7: the Spanish irregularity class (F2b, plan §4b row 8) ──────────────────────────
	// One `_label` (the alternation, shown as a chip) and one `_note` (the one line that explains
	// it) per class of the CLOSED set of 14 that `sense.verb_class` can hold. The example verb in
	// each note stays Spanish in every locale — it is the language being learned, not the language
	// being read.
	// ⛔ `ortografico` is 596 of the 1,032 classed verbs, so it is the COMMON case, and its note
	// must say that the spelling keeps the SOUND — calling it irregularity would be wrong about
	// three verbs in five.
	verb_class_tooltip: 'Irregularity class — how this verb’s stem moves. The highlighted present-tense cells are the ones that change; the rest follow the regular pattern.',
	verbClassOrtografico_label: 'spelling only',
	verbClassOrtografico_note: 'The spelling changes so that the sound does not: coger → cojo.',
	verbClassEIe_label: 'e → ie',
	verbClassEIe_note: 'The stem vowel breaks into a diphthong when it is stressed: tener → tiene.',
	verbClassOUe_label: 'o → ue',
	verbClassOUe_note: 'The stem vowel breaks into a diphthong when it is stressed: llover → llueve.',
	verbClassEI_label: 'e → i',
	verbClassEI_note: 'The stem vowel closes when it is stressed: pedir → pide.',
	verbClassEIeI_label: 'e → ie / i',
	verbClassEIeI_note: 'A diphthong when stressed, a closed vowel where it is not: sentir → siente, sintió.',
	verbClassOUeU_label: 'o → ue / u',
	verbClassOUeU_note: 'A diphthong when stressed, a closed vowel where it is not: dormir → duerme, durmió.',
	verbClassZco_label: '-zco',
	verbClassZco_note: 'The first person singular takes -zco, and every subjunctive cell follows it: conocer → conozco.',
	verbClassIAcento_label: 'i → í',
	verbClassIAcento_note: 'The weak vowel takes a written accent when stressed, so it keeps its own syllable: ampliar → amplío.',
	verbClassUAcento_label: 'u → ú',
	verbClassUAcento_note: 'The weak vowel takes a written accent when stressed, so it keeps its own syllable: actuar → actúo.',
	verbClassEAcento_label: 'e → í',
	verbClassEAcento_note: 'The stem e is written í when it is stressed: reír → río.',
	verbClassIIe_label: 'i → ie',
	verbClassIIe_note: 'The stem vowel breaks into a diphthong when it is stressed: adquirir → adquiere.',
	verbClassEYe_label: 'e → ye',
	verbClassEYe_note: 'The diphthong is written ye at the start of a word: errar → yerro.',
	verbClassUUe_label: 'u → ue',
	verbClassUUe_note: 'The stem vowel breaks into a diphthong when it is stressed: jugar → juega.',
	verbClassOHue_label: 'o → hue',
	verbClassOHue_note: 'The diphthong is written hue at the start of a word: oler → huele.',
	// ── SPANISH SENSE FIELDS (S4, 2026-09-08) ───────────────────────────────────────────
	// The copula and position splits, the sense's variety limits, and the shape of a
	// government frame. Region labels are looked up FROM THE CODE — never a prose prefix in
	// a gloss (register clause 14) and never a preposition in a template (a region reads as
	// `label: A, B`, because `en Espagne` / `au Mexique` cannot both come out of one hole).
	senseCopulaSer_label: 'with ser',
	senseCopulaEstar_label: 'with estar',
	senseCopulaAmbos_label: 'ser or estar',
	sensePositionPrenominal_label: 'before the noun',
	sensePositionPostnominal_label: 'after the noun',
	sensePositionEither_label: 'either position',
	senseRegionTypeOnlyIn_label: 'only',
	senseRegionTypeNotIn_label: 'not used',
	senseRegionTypePreferredIn_label: 'preferred',
	senseRegionES_label: 'Spain',
	senseRegionMX_label: 'Mexico',
	senseRegionAR_label: 'Argentina',
	senseRegionUY_label: 'Uruguay',
	senseRegionPY_label: 'Paraguay',
	senseRegionCL_label: 'Chile',
	senseRegionPE_label: 'Peru',
	senseRegionBO_label: 'Bolivia',
	senseRegionEC_label: 'Ecuador',
	senseRegionCO_label: 'Colombia',
	senseRegionVE_label: 'Venezuela',
	senseRegionCR_label: 'Costa Rica',
	senseRegionGT_label: 'Guatemala',
	senseRegionHN_label: 'Honduras',
	senseRegionNI_label: 'Nicaragua',
	senseRegionPA_label: 'Panama',
	senseRegionSV_label: 'El Salvador',
	senseRegionCU_label: 'Cuba',
	senseRegionDO_label: 'Dominican Republic',
	senseRegionPR_label: 'Puerto Rico',
	senseRegionGQ_label: 'Equatorial Guinea',
	senseRegionUS_label: 'United States',
	senseRegionAM_label: 'the Americas',
	senseRegionRPL_label: 'River Plate',
	senseRegionCAM_label: 'Central America',
	senseRegionAND_label: 'the Andes',
	senseRegionCAR_label: 'the Caribbean',
	senseRegionCAN_label: 'Canary Islands',
	senseConstructionPrepNp_label: '+ noun',
	senseConstructionPrepInf_label: '+ infinitive',
	senseConstructionPrepQueInd_label: '+ que + indicative',
	senseConstructionPrepQueSubj_label: '+ que + subjunctive',
	senseConstructionQueInd_label: 'que + indicative',
	senseConstructionQueSubj_label: 'que + subjunctive',
	senseConstructionInfDirecto_label: '+ bare infinitive',
	senseConstructionDativoExperimentante_label: 'dative experiencer · me gusta el café',
	senseConstructionObjetoDativo_label: '+ le (dative object)',
	senseConstructionObjetoAcusativo_label: '+ direct object',
	senseConstructionSeImpersonal_label: 'impersonal se',
	senseMoodInd_label: '+ indicative',
	senseMoodSubj_label: '+ subjunctive',

	// ── Session history: the popup behind the "N sessions" tile (js/session_history.js) ──
	hist_title: 'Session history',
	hist_tooltip: 'Every practice session you have finished with this pair',
	hist_back_label: 'Back',
	hist_loading: 'Loading…',
	hist_failed: 'Could not load your session history.',
	hist_empty: 'No finished practice sessions yet for this pair.',
	hist_today: 'Today',
	hist_yesterday: 'Yesterday',
	hist_col_time: 'Time',
	hist_col_mastered: 'Mastered',
	hist_col_flawless: 'Flawless',
	hist_col_accuracy: 'Accuracy',
	hist_col_shown: 'Shown',
	hist_col_wrong: 'Wrong',
	hist_col_spent: 'Spent',
	hist_col_typical: 'Typical',
	hist_of: 'of {0}',
	// The bare word, for the table cells that print the count and the total in their OWN columns
	hist_of_label: 'of',
	hist_stopped: 'stopped early',
	hist_dir_mix: 'Mix',
	hist_dir_byEar: 'By ear',
	hist_origin_random: 'Random words',
	hist_origin_search: 'Searched words',
	hist_origin_list: 'List: {0}',
	hist_fact_when: 'When',
	hist_fact_direction: 'Direction',
	hist_fact_source: 'Words from',
	hist_fact_set: 'Words in the set',
	hist_fact_shown: 'Times shown',
	hist_fact_correct: 'Right',
	hist_fact_wrong: 'Answer revealed',
	hist_fact_replays: 'Sound replays',
	hist_fact_outcome: 'Ended',
	hist_outcome_completed: 'Completed',
	hist_outcome_stopped: 'Stopped early',
	hist_flawless_legend: 'right every time — never revealed, never a wrong try',
	hist_firstTry_legend: 'right at the first showing — no wrong try on it',
	// ── what every figure on these two tables means (hover on the heading) ───────────────────
	// Each says the RULE, not a restatement of the heading: a learner who hovers "Accuracy" wants
	// the formula, and one who hovers "Wrong" wants to know why it does not count their typos.
	hist_tip_time: 'When this practice session started.',
	hist_tip_mastered: 'Words you finished with — retired for the day, out of the words the session set out to drill.',
	hist_tip_flawless: 'Words right on every showing: never revealed, and never a wrong answer entered along the way.',
	hist_tip_accuracy: 'Right ÷ shown. A showing ends either with your correct answer or with the answer being revealed, so this is the share you got yourself.',
	hist_tip_shown: 'How many times words were put in front of you for an answer, counting repeats.',
	hist_tip_right: 'How many of those showings you answered correctly — however many tries it took you inside the time limit.',
	hist_tip_wrong: 'How many showings ended with the answer being revealed: the timer ran out, or you asked to see it.',
	hist_tip_spent: 'From the first word to the last — the whole session, pauses included.',
	hist_tip_typical: 'How long a right answer usually took: the middle value across the words, so one long phrase cannot skew it.',
	hist_tip_direction: 'Which way the drill asked — the cue language first, the answer language second.',
	hist_tip_when: 'The day and clock time this session ran, start to finish.',
	hist_tip_source: 'Where the words came from.',
	hist_tip_set: 'How many words were staged for this session.',
	hist_tip_replays: 'How many times you played a word\'s sound again before answering. Help you asked for, not a mistake.',
	hist_tip_outcome: 'Whether the session ran to the end or was stopped early.',
	// The word table's own wordings — the same rules, said about ONE word
	hist_tip_word: 'The word this row is about. Click the row for its full learning history.',
	hist_tip_meaning: 'What this session drilled the word as — the meanings its cards actually asked for.',
	hist_tip_wshown: 'How many times this word was put in front of you for an answer.',
	hist_tip_wright: 'How many of those showings you answered correctly, however many tries it took inside the time limit.',
	hist_tip_wwrong: 'How many showings ended with the answer being revealed — the timer ran out, or you asked to see it.',
	hist_tip_wtypical: 'Your average time to a right answer on this word. Showings you never answered do not count.',
	hist_tip_firstTry: 'Right at the very first showing, with no wrong answer entered on it — a word you already knew. What happened on the repeats does not affect it.',
	hist_tip_wflawless: 'Right on every showing, never revealed, and never a wrong answer entered. Stricter than a clean first try.',
	hist_words_none: 'No words were recorded for this session.',
	hist_words_masteredHead: 'Mastered ({0})',
	hist_words_alsoHead: 'Also drilled ({0})',
	hist_words_noMatch: 'No word matches that filter.',
	hist_wcol_word: 'Word',
	hist_wcol_meaning: 'Meaning',
	hist_wcol_firstTry: '1st try',
	hist_wcol_replays: 'Replays',
	hist_wcol_right: 'Right',
	// The scheduling trio — on both word tables, the finish screen's own three facts about what
	// happens to a word AFTER the session.
	hist_wcol_growth: 'Growth',
	hist_wcol_next: 'Next',
	hist_wcol_verdict: 'Verdict',
	hist_tip_growth: 'Your plant for this word before and after the session. An arrow means it grew a stage; a single, faded plant means it held the stage it was on — which is the normal outcome for a word practiced before it was due.',
	hist_tip_grew: 'This session grew the plant a stage.',
	hist_tip_next: 'How many days the app scheduled this word out for after this session — the interval it was willing to wait before asking again. Longer means the memory is holding.',
	hist_tip_next_drawn: 'This session drew a new date for the word: {0}.',
	hist_tip_next_held: 'This session did not redraw the date — an early practice or a same-day repeat leaves the standing promise alone. Still due {0}.',
	hist_tip_verdict: 'What the memory model made of this word here, in its own words. It can differ from how the drill felt: a word you fought for can still count as retrieved, and a word that came out right can still be logged as slow.',
	hist_days_short: '{0} d',
	// The chip labels: short, because they live in a column.
	hist_v_cold: 'recalled cold',
	hist_v_slow: 'known, slow',
	hist_v_article: 'known, article',
	hist_v_warmUp: 'warm-up',
	hist_v_relearned: 'relearned',
	hist_v_early: 'early',
	hist_v_sameDay: 'same day',
	// …and what each one MEANS. This is the app's own vocabulary — nothing outside it teaches
	// what "recalled cold" is — so the hover explains the verdict rather than rephrasing it
	// (these keys replaced the finish screen's exOutcome_* sentences, which for "recalled cold"
	// gave a tooltip repeating the chip word for word). Each says what the app saw, and what it
	// did about it. The rules behind them are SrsFinishService's class list.
	hist_vtip_cold: 'You produced the word right away, first try, with no help, and the app saw nothing slow about it. The cleanest kind of remembering — and what moves the plant on to its next stage.',
	hist_vtip_slow: 'You got there on your own, with no help, but over the time the app allows for this word — a budget built from how fast you type, not a fixed clock. It counts as knowing it, a near-miss spelling included: the memory is there, it is just not quick yet.',
	hist_vtip_article: 'The word itself came back; the article (der / die / das) did not. It counts as knowing the word — the gender is the part still to learn, and the app keeps asking for both.',
	hist_vtip_warmUp: 'The word came back, but not cleanly: a near-miss spelling the app let through, a wrong answer you submitted and fixed on the spot, or one so slow it reads as rebuilt rather than recalled. The drill may still have shown you the answer along the way — this line is about what came back, not about what the drill did. It falls short of a clean recall rather than counting as a miss.',
	hist_vtip_relearned: 'The word was rebuilt rather than recalled: it did not come back on its own this time, so the drill showed it to you and had you produce it again. Nothing is lost and the plant never shrinks — the word simply comes back sooner, and you carry on from where you were.',
	hist_vtip_early: 'You practiced this word before its watering date and did not miss it. Practice taken early counts for less than practice taken when the word is due — the plant can still step up if the memory has grown enough, it just takes more to get there.',
	hist_vtip_sameDay: 'This word came round again within about six hours of the last time it counted — too soon to prove anything new, so nothing was measured and nothing grew. Memory grows in the gaps between practices, not inside one.',

	// ── Word statistics (the "words mastered" tile) + one word's history ──────────────────
	hist_ws_title: 'Word statistics',
	hist_ws_tooltip: 'Every word you have practiced with this pair — lifetime numbers, trends, and each word\'s own history',
	hist_ws_empty: 'No words practiced yet for this pair.',
	hist_ws_count: '{0} words · {1} mastered',
	hist_ws_col_sessions: 'Sessions',
	hist_ws_col_trend: 'Trend',
	hist_ws_col_mastered: 'Mastered',
	hist_ws_mastered_legend: 'mastered in at least one session — these add up to the tile\'s number',
	hist_ws_tip_word: 'The word this row is about. Click the row for its full history.',
	hist_ws_tip_sessions: 'How many finished practice sessions included this word.',
	hist_ws_tip_shown: 'How many times this word was put in front of you for an answer, over all sessions.',
	hist_ws_tip_right: 'Showings you answered correctly, over all sessions.',
	hist_ws_tip_wrong: 'Showings that ended with the answer being revealed — the timer ran out, or you asked to see it.',
	hist_ws_tip_accuracy: 'Right ÷ shown, over the word\'s whole history.',
	hist_ws_tip_typical: 'Your average time to a right answer on this word, over all sessions.',
	hist_ws_tip_trend: 'Answer speed, later sessions against earlier ones. ▼ means faster. Needs a few timed sessions before it says anything.',
	hist_ws_tip_mastered: 'Brought to done in at least one session — answered right the required number of times. These rows add up to the "words mastered" tile.',
	hist_ws_chart_speed: 'Typical answer time by session',
	hist_ws_tip_chart_speed: 'Each point is one finished session: its typical (median per-word) time to a right answer. A falling line is you getting faster.',
	hist_ws_chart_mastered: 'Words mastered over time',
	hist_ws_tip_chart_mastered: 'Words mastered, added up session by session.',
	hist_chart_few: 'Not enough practice here yet to draw.',
	hist_wh_tip_dictionary: 'Open this word\'s full dictionary entry.',
	hist_wh_none: 'This word has not been practiced yet.',
	hist_wh_col_when: 'When',
	hist_wh_tip_when: 'The session that drilled this word — its day and start time. Click the row to open that session.',
	hist_wh_firstSeen: 'First practiced',
	hist_wh_tip_firstSeen: 'The first session this word appeared in.',
	hist_wh_lastSeen: 'Last practiced',
	hist_wh_tip_lastSeen: 'The most recent session this word appeared in.',
	hist_wh_stage: 'Plant stage',
	hist_wh_tip_stage: 'The word\'s plant in your garden — it grows a stage with each successful spaced review, up to 7.',
	hist_wh_due: 'Next watering',
	hist_wh_tip_due: 'When the app plans to check this word again. Reviews are spaced further apart as the memory strengthens.',
	hist_wh_overdue: 'overdue',
	hist_wh_lapses: 'Lapses',
	hist_wh_tip_lapses: 'Reviews where the word had slipped away and had to be relearned.',
	hist_wh_article: 'Article',
	hist_wh_articleNone: 'none typed',
	hist_wh_tip_article: 'The times you produced this word but reached for the wrong article. These count as knowing the word — it is the gender that needs practice, and the article drill picks these up.',
	hist_wh_chart_speed: 'Answer speed',
	hist_wh_tip_chart_speed: 'The line is your typical time to a right answer, per session. The small dots are individual showings. An ✗ along the top is a showing where the answer had to be revealed.',
	hist_wh_chart_gaps: 'Days between practices',
	hist_wh_tip_chart_gaps: 'The gap before each practice of this word. Growing gaps are a strengthening memory: the app dares to wait longer and you still remember. The outlined bar is the next scheduled review. The dashed line is what the app had promised at each session — above its bar means you came back sooner than you had to.',
	hist_wh_scheduled: 'scheduled',
	hist_wh_chart_stage: 'Plant growth',
	hist_wh_tip_chart_stage: 'The garden stage after each counted review. Green: the review passed. Red: the word slipped and the plant was set back.',
	hist_wh_chart_acc: 'Accuracy by session',
	hist_wh_tip_chart_acc: 'Right ÷ shown, in each session that drilled this word.',
	hist_wh_revealed: 'revealed',
	hist_wh_pass: 'passed',
	hist_wh_fail: 'slipped',
	// ── The accuracy root (the "accuracy" tile) + the time root (the "studied" tile) ─────────
	hist_acc_title: 'Accuracy',
	hist_acc_tooltip: 'How your accuracy is built and how it changes — session by session, and the words that pull it down',
	hist_acc_firstTry_lbl: 'known on sight',
	hist_acc_tip_accuracy: 'Right ÷ shown over everything you have practiced with this pair — the same number the panel\'s tile shows.',
	hist_acc_tip_firstTry: 'Words answered right at their very first showing, out of every word your sessions put in front of you. The gap to your accuracy is what the drilling itself contributes.',
	hist_acc_tip_chart_bySession: 'Right ÷ shown for each finished session, oldest to newest.',
	hist_acc_chart_firstTry: 'Known on sight by session',
	hist_acc_tip_chart_firstTry: 'The share of each session\'s words answered right at their very first showing — recognition, before the drilling starts helping.',
	hist_acc_hard_head: 'Hardest words ({0})',
	hist_acc_hard_sub: 'lowest accuracy, among words shown at least {0} times — click a word for its full history',
	hist_acc_hard_none: 'No word stands out — nothing shown often enough has a low accuracy.',
	hist_time_title: 'Time studied',
	hist_time_tooltip: 'Where your study time went — day by day, in total, and what an hour of practice buys',
	hist_time_typical_lbl: 'typical session',
	hist_time_days_lbl: 'active days',
	hist_time_tip_total: 'Every finished session\'s length added up. Pauses inside a session count; the time between sessions does not.',
	hist_time_tip_sessions: 'Finished practice sessions for this pair — the same count as the panel\'s tile.',
	hist_time_tip_typical: 'The middle session length: half your sessions were shorter, half longer, so one marathon evening cannot skew it.',
	hist_time_tip_days: 'Days with at least one finished session. A day runs to 3:00 in the morning, so a midnight session belongs to its evening.',
	hist_time_fact_longest: 'Longest session',
	hist_time_tip_longest: 'Your single longest sitting, and the day it happened.',
	hist_time_fact_perDay: 'Average per active day',
	hist_time_tip_perDay: 'Total study time ÷ the days you actually practiced.',
	hist_time_fact_perWord: 'Per word mastered',
	hist_time_tip_perWord: 'Total study time ÷ distinct words mastered — what one lasting word costs you. Falling over time is the win.',
	hist_time_chart_byDay: 'Practice time by day',
	hist_time_tip_chart_byDay: 'Minutes of finished practice on each day you studied — gaps are days without practice.',
	hist_time_chart_total: 'Total hours over time',
	hist_time_tip_chart_total: 'Study time added up session by session. A steady habit reads as a steady slope.',

	// ── Feedback: the 💬 dialog (js/feedback.js) ──
	// The app never ASKS for feedback, so none of these strings may nudge: they name the four
	// kinds, ask what happened, and stop.
	feedback_menu: 'Send feedback',
	feedback_title: 'Send feedback',
	feedback_type_problem: 'Problem',
	feedback_type_dislike: 'Don\'t like',
	feedback_type_like: 'Like',
	feedback_type_idea: 'Suggestion',
	feedback_type_question: 'Question',
	// Shown before any type is picked; each type then replaces it with its own question.
	feedback_ph_start: 'Pick one above, then write your message',
	feedback_ph_problem: 'What went wrong?',
	feedback_ph_dislike: 'What don\'t you like?',
	feedback_ph_like: 'What do you like?',
	feedback_ph_idea: 'What could work better?',
	feedback_ph_question: 'What would you like to know?',
	feedback_email_label: 'Email for a reply (optional)',
	feedback_send: 'Send',
	feedback_cancel: 'Cancel',
	feedback_thanks: 'Thank you! We read every message.',

	// ── Owner-only word-decision audit table (session-word-audit.md; session_history.js
	// SESSION_HISTORY.openAudit, main.js auditFinishPill) — a testing tool, not a user feature:
	// gated server-side by user id, so these strings are seen only by the owner. Terse and
	// technical throughout on purpose (density over prettiness), unlike the rest of this file.
	audit_title: 'Word audit',
	audit_none: 'No audit was captured for this session.',
	audit_empty: 'This session has no audited words.',
	audit_finish_tooltip: 'Owner-only: the full decision rationale behind every word of this session',
	audit_history_chip: 'audit',
	audit_y_pass: 'pass',
	audit_y_fail: 'fail',
	audit_y_void: 'void',
	// The showings grid
	audit_col_seq: 'Seq',
	audit_col_outcome: 'Outcome',
	audit_col_tier: 'Tier',
	audit_col_latency: 'Latency',
	audit_col_shownTs: 'Shown at',
	audit_outcome_PASS: 'pass',
	audit_outcome_FAIL: 'fail',
	audit_outcome_TIMEOUT: 'timeout',
	audit_outcome_MEET: 'meet',
	audit_outcome_REVEAL: 'reveal',
	// The attempts grid, nested under each showing
	audit_acol_attempt: '#',
	audit_acol_submitted: 'Typed',
	audit_acol_correct: 'Correct',
	audit_acol_similarity: 'Sim',
	audit_acol_errorClass: 'Error',
	audit_acol_firstKeyMs: '1st key',
	audit_acol_completionMs: 'Completion',
	audit_acol_allottedMs: 'Allotted',
	audit_acol_keystrokes: 'Keys',
	audit_acol_backspaces: 'Backsp',
	audit_yes: 'Yes',
	audit_no: 'No',
	audit_censored: 'censored',
	// The three full blocks — every field of label/m5/garden the shipped code produced
	audit_group_label: 'Label',
	audit_group_m5: 'M5',
	audit_group_garden: 'Garden',
	audit_f_y: 'y',
	audit_f_labelFlags: 'Flags',
	audit_f_nPres: 'n presentations',
	audit_f_nMin: 'n min',
	audit_f_criterionMet: 'Criterion met',
	audit_f_g: 'g',
	audit_f_gFinal: 'g final',
	audit_f_epsilon: 'Epsilon',
	audit_f_lStarMs: 'L*',
	audit_f_sBefore: 'S before',
	audit_f_sAfter: 'S after',
	audit_f_dAfter: 'D after',
	audit_f_rHat: 'R̂',
	audit_f_rStar: 'R*',
	audit_f_intervalDays: 'Δdays',
	audit_f_floored: 'Floored',
	audit_f_dueTs: 'Due',
	audit_f_algoVersion: 'Algo version',
	audit_f_decisionType: 'Decision type',
	audit_f_stageBefore: 'Stage before',
	audit_f_stageAfter: 'Stage after',
	audit_f_result: 'Result',
	audit_f_wasDue: 'Was due',
	audit_f_promoted: 'Promoted',
	audit_f_planted: 'Planted',
	audit_f_grew: 'Grew',
	audit_f_lapses: 'Lapses',
	// The P4 shadow-verdict strip (verdict v2 in shadow, garden-srs-implementation-plan.md P4) —
	// a compact addendum per word, sourced from the shadow service's own computed data.
	// The DECIDING slice — the grid in force, the two decisions it drove, and the one door back
	// to everything trimmed out of them (session-word-audit.md).
	audit_group_verdict: 'Verdict',
	audit_group_flower: 'Flower',
	audit_decision_head: 'Decision',
	audit_f_notch: 'Notch',
	audit_f_band: 'band ≥',
	audit_f_showingsPlanned: 'planned',
	audit_f_bucket: 'Bucket',
	audit_f_nextMarkDays: 'Next mark (d)',
	audit_f_otherEngine: 'Other engine said',
	audit_f_dueModel: 'Due (model)',
	audit_f_nextShown: 'Next shown',
	audit_more_showings: 'more showings after the seal — evidence only',
	audit_more_details: 'Everything else (full showings, all notches, verbatim blocks)',
	// The one-line-per-word default view: the whole spec §3 grid row per word as
	// `required → actual`, with the ONE gate that sealed a failure flagged and named. Time and r*
	// are shown dimmed — nothing reads them yet, and the hover says why.
	audit_lcol_showings: 'Showings',
	audit_lcol_peeks: 'Peeks',
	audit_lcol_time: 'Time',
	audit_lcol_close: 'Close',
	audit_lcol_rstar: 'r*',
	audit_lcol_flower: 'Flower',
	audit_lcol_why: 'Why',
	audit_words_count: '{0} words',
	audit_grid_mixed: ' · mixed notches',
	audit_gate_perfect: 'perfect',
	audit_gate_off_peeks: 'A peek budget exists only on family A (notches 1–3).',
	audit_gate_off_time: 'Observational only — the composition never reads the time dial. Actual = notch weight × latency/allotted ({0}) of the deciding showing.',
	audit_gate_off_rstar: 'M5 scheduled against r* {0}; the per-notch target is inert until the P7 flip.',
	audit_gate_off_close_c: 'Family C ignores the band: the gate is a perfect showing (≥ {0} never read).',
	audit_why_close: 'below band at showing {0}',
	audit_why_peek: 'peeks over budget at showing {0}',
	audit_why_perfect: 'not perfect at showing {0}',
	audit_why_void: 'sealed nowhere — {0} of {1} shown',
	audit_why_pass: 'passed at showing {0}',
	audit_why_unknown: 'sealed at showing {0} — family not recorded',
	audit_v2_title: 'v2 (shadow)',
	audit_v2_sealedAt: 'Sealed at',
	audit_v2_evid_col_seq: '#',
	audit_v2_evid_col_perfect: 'Perfect',
	audit_v2_evid_col_sim: 'Evidence sim',
	audit_v2_evid_col_veto: 'Veto',
	audit_v2_guardFlags: 'Guard flags',
	audit_v2_gradedCut: 'Graded cut',
	// ── Strictness slider live caption (strictness_captions.js STRICTNESS.captionFor): one plain
	// sentence per notch saying what a word needs to pass there — the deed, then how many times
	// (garden-srs-redesign-spec.md §3 grid: 1–3 = from memory after at most 2/1/1 looks at the
	// answer; 4–6 = a close-enough attempt before the answer is revealed, in 1/2/2 showings;
	// 7–10 = the exact answer before the countdown ends, in 2/3/3/3 showings). The closeness
	// adverb is the honest dimmer across 1–6 (very rough → rough → roughly right → close enough →
	// almost exactly); 8–10 share one rule and differ by emphasis only. Rewritten 2026-09-01 from
	// the spec's sample-tone copy ("comes back on its own, close enough") after the owner asked
	// what "comes back" meant — the drill's own words instead: "type it from memory", "revealed",
	// "the countdown". Ten distinct captions (temp/check-strictness-captions.mjs), each within the
	// two lines the panel reserves (temp/ui-smoke/strictness-caption-width-probe.mjs).
	strictness_captionN1: 'You may see the answer up to two times, then type it from memory — very rough spelling is fine',
	strictness_captionN2: 'You may see the answer once, then type it from memory — very rough spelling is fine',
	strictness_captionN3: 'You may see the answer once, then type it from memory — rough spelling is fine',
	strictness_captionN4: 'Type the word roughly right before the answer is revealed, once',
	strictness_captionN5: 'Type the word close enough before the answer is revealed, twice',
	strictness_captionN6: 'Type the word almost exactly before the answer is revealed, twice',
	strictness_captionN7: 'Type the word exactly before the countdown ends, twice',
	strictness_captionN8: 'Type the word exactly before the countdown ends, three times',
	strictness_captionN9: 'Type the word exactly before the countdown ends, three times in a row',
	strictness_captionN10: 'Type the word exactly before the countdown ends, every single time — no help at all',
	// ── Part-of-speech display labels (pos_label.js) — one abbreviation + one tooltip per
	// canonical pos concept. Two source vocabularies canonicalize onto one key here (see CANON in
	// pos_label.js): the rich dictionary's English sense.pos, and the legacy PartOfSpeech enum,
	// English on EN terms but French on FR terms ("nom", "verbe", "adjectif" all land on the
	// English-named key below). "noun"/"verb" stay whole — by far the most common labels and
	// already inside the 5-char budget — so their _label equals their _tooltip and wire() shows
	// no tip for them.
	posNoun_label: 'noun',
	posNoun_tooltip: 'noun',
	posVerb_label: 'verb',
	posVerb_tooltip: 'verb',
	posAdjective_label: 'adj',
	posAdjective_tooltip: 'adjective',
	posAdverb_label: 'adv',
	posAdverb_tooltip: 'adverb',
	posPhrase_label: 'phr',
	posPhrase_tooltip: 'phrase',
	// A conjugated combo persisted as its own term ("ich stehe auf") — pos "phrase_verb_conj".
	posPhraseVerbConj_label: 'vform',
	posPhraseVerbConj_tooltip: 'conjugated verb form',
	// A principal-parts card persisted as its own term ("go, went, gone") — pos "verb_forms".
	posVerbForms_label: 'forms',
	posVerbForms_tooltip: "verb's principal forms",
	posPreposition_label: 'prep',
	posPreposition_tooltip: 'preposition',
	posPronoun_label: 'pron',
	posPronoun_tooltip: 'pronoun',
	posConjunction_label: 'conj',
	posConjunction_tooltip: 'conjunction',
	posInterjection_label: 'intrj',
	posInterjection_tooltip: 'interjection',
	posNumeral_label: 'num',
	posNumeral_tooltip: 'numeral',
	posArticle_label: 'art',
	posArticle_tooltip: 'article',
	// Spanish needs this one and English barely has it as a category of its own: mi, tu, su, este,
	// ese, aquel, algún, ningún, cada, todo, mucho, poco, otro, cualquier, cierto, tanto, ambos,
	// varios — ~40 rows in the Spanish top 1,000, and nearly all of them double as pronouns (este
	// libro / este es mío), which only resolves because pos is per SENSE. There is already one row
	// carrying pos='determiner' in the database, and until now it rendered as truncated "deter".
	posDeterminer_label: 'det',
	posDeterminer_tooltip: 'determiner',
	posAbbreviation_label: 'abbr',
	posAbbreviation_tooltip: 'abbreviation',
	posParticle_label: 'part',
	posParticle_tooltip: 'particle',
	posPrefix_label: 'pref',
	posPrefix_tooltip: 'prefix',
	// ── Form kinds (56,193 thin word_form rows: 42,095 DE, 14,098 EN). These are not parts of
	// speech — a form row stores its KIND in sense.pos, the phrase_verb_conj precedent. Same 5-char
	// budget and the same no-trailing-dot convention as everything above.
	// ⚠️ Tooltips are kept in step with WORD_FORM_KINDS_EN (main.js), which names the same kinds in
	// the rich entry's explanation line ("past tense of play"). Change the two together.
	// Two deliberate departures: `other` is "other" here rather than "form of", because PosLabel
	// also sees pos='other' on ordinary head senses, not just on form rows; and `contraction` is
	// "contraction" while `abbreviation` keeps its own tooltip, so the two never read alike.
	posPlural_label: 'pl',
	posPlural_tooltip: 'plural',
	posGenitiveSg_label: 'gen',
	posGenitiveSg_tooltip: 'genitive singular',
	posDeclined_label: 'decl',
	posDeclined_tooltip: 'declined form',
	posPast_label: 'past',
	posPast_tooltip: 'past tense',
	posPreterite_label: 'pret',
	posPreterite_tooltip: 'preterite (simple past)',
	posPastParticiple_label: 'ptcp',
	posPastParticiple_tooltip: 'past participle',
	posPresent1Sg_label: '1sg',
	posPresent1Sg_tooltip: 'present, 1st person singular',
	posPresent2Sg_label: '2sg',
	posPresent2Sg_tooltip: 'present, 2nd person singular',
	posPresent3Sg_label: '3sg',
	posPresent3Sg_tooltip: 'present, 3rd person singular',
	posImperative_label: 'imper',
	posImperative_tooltip: 'imperative',
	posSubjunctiveII_label: 'subj2',
	posSubjunctiveII_tooltip: 'subjunctive II',
	posSeparableParticle_label: 'sep',
	// ⛔ NOT 'separable prefix': the row this labels is the FINITE VERB HALF ('stehe', lemma
	// 'aufstehen'), not the prefix ('auf'). Twinned with WORD_FORM_KINDS_EN.separable_particle in
	// main.js ("separable form of") — a learner sees both on one screen, so they must agree.
	posSeparableParticle_tooltip: 'separable form',
	posComparative_label: 'comp',
	posComparative_tooltip: 'comparative',
	posSuperlative_label: 'sup',
	posSuperlative_tooltip: 'superlative',
	posIngForm_label: '-ing',
	posIngForm_tooltip: '-ing form',
	posContraction_label: 'contr',
	posContraction_tooltip: 'contraction',
	posSuppletive_label: 'supp',
	posSuppletive_tooltip: 'suppletive form',
	posProperNoun_label: 'prop',
	posProperNoun_tooltip: 'proper noun',
	posSpellingVariant_label: 'var',
	posSpellingVariant_tooltip: 'spelling variant',
	posFusion_label: 'fus',
	posFusion_tooltip: 'fused form',
	posOther_label: 'other',
	posOther_tooltip: 'other'
};
document.res_en = document.res_;
